import React, { useState, useEffect, useRef } from "react";

import doticon from "../../../assets/images/doticon.png";
import bell from "../../../assets/images/bell.png";
import walleto from "../../../assets/images/walleto.png";
import meta from "../../../assets/images/meta.png";
import defi from "../../../assets/images/defi.png";
import ledger from "../../../assets/images/ledger.png";
import browserRoute from "../../../Routes/browserRoutes";
import { Link } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Images from "./../../Helper/AllImages";
import Darkmode from "darkmode-js";
import { closeTransactionHistoryModal } from "../../../Services/mainServices";
import Web3 from "web3";
import {
  createKeyStore,
  connectKeyStore,
  MetaMaskConnection,
  handleMainModal,
  handleLogout,
  WalletConnectConnection,
  XDEFIConnection,
  NGROK,
} from "../../../Services/mainServices";
import axios from "axios";
import {
  SET_NOTIFICATIONS_DATA,
  SET_SETTINGS,
} from "../../../Redux/actions/types";

const web3 = new Web3(window.ethereum);

export const Header = () => {
  const options = {
    bottom: "64px", // default: '32px'
    right: "unset", // default: '32px'
    left: "32px", // default: 'unset'
    time: "0.5s", // default: '0.3s'
    mixColor: "#fff", // default: '#fff'
    backgroundColor: "#fff", // default: '#fff'
    buttonColorDark: "#100f2c", // default: '#100f2c'
    buttonColorLight: "#fff", // default: '#fff'
    saveInCookies: false, // default: true,
    autoMatchOsTheme: true, // default: true
  };
  const darkmode = new Darkmode(options);
  const [loading, setLoading] = useState(false);
  const Enum = {
    successfull: "success",
    unsuccessfull: "unsuccessfull",
    pending: "pending",
  };
  const [statusType, setStatusType] = useState(Enum.pending);
  const [createKeyStoreModal, setCreateKeyStoreModal] = useState(false);
  const [connectKeyStoreModal, setConnectKeyStoreModal] = useState(false);
  // const [mainModal, setMainModel] = useState(false);
  const [selectionModal, setSelectionModal] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [response, setResponse] = React.useState("");
  const [fileKeyStore, setFileKeyStore] = useState("");
  const [keyStoreObject, setKeyStoreObject] = useState({});
  const [selectedLang, setSelectedLang] = useState("ENG");
  const [connectKeyStore_password, setConnectKeyStore_password] = useState("");
  const [title, setTitle] = useState("");
  const [notificationPopup, setNotificationPopup] = useState(false);
  const [languageDropDown, setLanguageDropDown] = useState(false);
  const [learnDropDown, setLearnDropDown] = useState(false);
  const [passwordMatchError, setPasswordMatchError] = useState(false);
  const [xdefiExtension, setXdefiExtension] = useState(false);
  const [passwordEmptyError, setPasswordEmptyError] = useState(false);
  const myRef = useRef();
  const myRefLanguage = useRef();
  const myRefLearn = useRef();
  const hiddenFileInput = useRef(null);
  const [responseMsg, setResponseMsg] = useState("Transaction is Pending");
  const mainState = useSelector((state) => state.main);
  const mainModal = useSelector((state) => state.main.mainModal);
  const keyStoreClient = useSelector((state) => state.main.KeyStoreClient);
  const loggedIn = useSelector((state) => state.main.isLoggedin);
  const notificationData = useSelector((state) => state.main.notificationData);
  const walletAddress = useSelector((state) => state.main.walletAddress);
  const transactionHistoryModal = useSelector(
    (state) => state.main.transactionHistoryModal
  );
  const swappingData = useSelector((state) => state.main.swappingData);
  const [transactionHistoryModalState, setTransactionHistoryModalState] =
    useState(false);
  const transationHash = useSelector((state) => state.main.transactionHash);
  const midgardPool = useSelector((state) => state.main.midgardPool);
  let timeOut;

  const [nData, setNData] = useState([]);
  const [unReadNotifications, setUnReadNotifications] = useState(false);
  const xdfiExtension = useSelector((state) => state.main.xdfiExtension);
  useEffect(() => {
    if (transactionHistoryModal) {
      setTransactionHistoryModalState(true);
    }
  }, [transactionHistoryModal]);

  useEffect(() => {
    if (xdfiExtension) {
      setXdefiExtension(xdfiExtension);
    } else {
      setXdefiExtension(xdfiExtension);
    }
  }, [xdfiExtension]);

  useEffect(() => {
    let addresses;
    if (keyStoreClient?.length > 0) {
      addresses = keyStoreClient.map((d) => d.Address);
    }
    console.log("><><>< ADDRESSES ><><><>< ", addresses);
  }, [keyStoreClient]);

  // useEffect(() => {
  //   if (notificationData?.length > 0) {
  //     setNData(notificationData);
  //   }
  // }, [notificationData]);

  const getNotificationsData = async () => {
    const add = keyStoreClient.map((d) => d.Address);
    const data = {
      clients: add,
    };
    console.log("__________NOTIFICATIONS ADDRESSS _____ ", add);

    // for (let i = 0; i < keyStoreClient?.length; i++) {
    axios
      .post(`${NGROK}/get/client/transactions`, data)
      .then(
        (e) => (
          dispatch({
            type: SET_NOTIFICATIONS_DATA,
            payload: {
              notificationData: e?.data,
            },
          }),
          setNData(e?.data?.reverse()),
          console.log("__________NOTIFICATIONS DATA_____ ", e?.data)
        )
      )
      .catch((e) => console.log("______ERR Notifications______ ", e));
  };

  useEffect(() => {
    if (loggedIn && walletAddress && keyStoreClient) {
      // console.log("><<>< ADDDDDDD ><<><>>< ", keyStoreClient);
      getNotificationsData();

      // }
    }
  }, [loggedIn]);

  useEffect(() => {
    if (nData?.length > 0) {
      let count = 0;
      for (var i = 0; i < nData.length; i++) {
        if (nData[i].isVisited === false) {
          count++;
        }
      }
      if (count > 0) {
        setUnReadNotifications(true);
      } else {
        setUnReadNotifications(false);
      }
    }
  }, [nData]);

  const res = "";

  let tHash = "";

  const setNewUserAddress = async () => {
    const data = {
      accountAddress: walletAddress,
    };

    await axios.post(`${NGROK}/add/user`, data).then((res) => {
      console.log("RESSSSS =<><><><<><><><><><><<><><><>>< ", res);
    });
  };

  const getUserSettingsFromAddress = async () => {
    // console.log(addr);
    await axios
      .get(`${NGROK}/get/user/data/${walletAddress}`)
      .then((res) => {
        dispatch({
          type: SET_SETTINGS,
          payload: {
            settings: {
              custom: res?.data?.user?.custom,
              slip: res?.data?.user?.slip,
              speed: res?.data?.user?.speed,
            },
          },
        });
        console.log(
          "RESSSSS =<><><><<NotificationsData><><><><><><<><><><>>< ",
          res?.data.user
        );
      })
      .catch((e) => console.log("ERR GETTING NOTIFICATIONS ><<>", e));
  };

  const addHoldingAsset = async () => {
    const data = {
      accountAddress: mainState?.walletAddress,
      amount: mainState?.overallBalance_USD.toString(),
      date: new Date().toString(),
    };
    axios.post(`${NGROK}/add/holding/asset`, data).then((res) => {
      console.log("CHECKING_HOLDING RES=============", res);
    });
  };

  // useEffect(() => {
  //   if (mainState?.walletAddress) {
  //     if (mainState?.walletAddress) {
  //       // setWalletAddressState(walletAddress)
  //     }
  //   }
  // }, [mainState]);

  //sleep

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  useEffect(() => {
    if (walletAddress) {
      setNewUserAddress();
      addHoldingAsset();
      getUserSettingsFromAddress();
    }
  }, [walletAddress]);
  const checkTransaction = async (tHash) => {
    // console.log("HELLLLLLLLLLLLLLLOOOOO");
    let res;
    let interval = setInterval(async () => {
      res = await axios.get(`${NGROK}/get/transaction/status/${tHash}`);
      console.log("CHECKING_HASH=============", res?.data?.count);

      if (Number(res?.data?.count) > 0) {
        let data = res?.data;

        let status = data?.actions[0]?.type;
        let message = "";

        if (status === "refund") {
          message = " unsuccessfull";

          setStatusType(Enum.unsuccessfull);
          setResponseMsg("This Transaction is " + message);
          await sleep(5000);
          dispatch(closeTransactionHistoryModal());
          getNotificationsData();

          // setTransactionHistoryModalState(false);
          return;
        }

        message = " successfull";
        setStatusType(Enum.successfull);
        setResponseMsg("This Transaction is " + message);

        await sleep(5000);
        dispatch(closeTransactionHistoryModal());
        getNotificationsData();

        // setTransactionHistoryModalState(false);

        clearInterval(interval);
        return;
      }
    }, 30000);
  };

  useEffect(() => {
    if (transationHash) {
      console.log("I am here3 -------------------->");

      tHash = transationHash;
      console.log("thash-=================", tHash);
      checkTransaction(tHash);
    }
  }, [mainState.transactionHash]);

  useEffect(() => {
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
    function handleClick(e) {
      if (myRef && myRef.current) {
        const ref = myRef.current;
        if (!ref.contains(e.target)) {
          setNotificationPopup(false);
        }
      }
      if (myRefLanguage && myRefLanguage.current) {
        const ref2 = myRefLanguage.current;
        if (!ref2.contains(e.target)) {
          setLanguageDropDown(false);
        }
      }
      if (myRefLearn && myRefLearn.current) {
        const ref2 = myRefLearn.current;
        if (!ref2.contains(e.target)) {
          setLearnDropDown(false);
        }
      }
    }
  }, []);

  // Crypto Constants for xchain
  const cipher = "aes-128-ctr";
  const kdf = "pbkdf2";
  const prf = "hmac-sha256";
  const dklen = 32;
  const c = 262144;
  const hashFunction = "sha256";
  // const meta = "xchain-keystore";
  let key;
  let fileReader;
  const dispatch = useDispatch();

  // console.log(loggedIn);
  useEffect(() => {
    if (loggedIn) {
      setTitle("Disconnect");
    } else {
      setTitle("Connect");
    }
  }, [loggedIn]);

  const setMainModel = async (val) => {
    const acc = await web3.eth;
    const xdf = await window.xfi;

    // const prov = await window.ethereum.enable();
    // console.log("modal prov==== ", prov);
    // console.log("modal eth==== ", acc);
    // console.log("modal xdf==== ", xdf);

    // const bal = await web3.eth.getBalance(acc[0]);
    // console.log("modal bal==== ", bal);

    if (val == true) {
      const eth = await window.xfi;
      if (
        eth?.binance &&
        eth?.bitcoin &&
        eth?.ethereum &&
        eth?.terra &&
        eth?.thorchain
      ) {
        let xdf = true;
        // setXdefiExtension(true);
        dispatch(handleMainModal(val, xdf));
      } else {
        let xdf = false;
        // setXdefiExtension(false);

        dispatch(handleMainModal(val, xdf));
      }
    } else {
      let xdf = false;

      setXdefiExtension(false);
      dispatch(handleMainModal(val, xdf));
    }
  };
  const submitKeyStore = async () => {
    if (password.length < 1) {
      setPasswordEmptyError(true);
    } else if (password != confirmPassword) {
      setPasswordMatchError(true);
    } else {
      if (!passwordEmptyError && !passwordMatchError) {
        dispatch(createKeyStore(password, setCreateKeyStoreModal));
      } else {
        setPasswordMatchError(true);
      }
    }
  };

  const connectKeyStoreFunction = async () => {
    if (midgardPool) {
      dispatch(
        connectKeyStore(
          connectKeyStore_password,
          fileKeyStore,
          setConnectKeyStoreModal,
          setLoading,
          midgardPool
        )
      );
    }
  };

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };
  const connectMetaMask = async () => {
    dispatch(MetaMaskConnection(setMainModel));
  };

  const connectWalletConnect = async () => {
    dispatch(WalletConnectConnection(setMainModel));
  };

  const connectXdefi = async () => {
    if (midgardPool) {
      setLoading(true);
      dispatch(XDEFIConnection(setMainModel, setLoading, midgardPool));
    }
  };

  const handleLanguageChange = (event) => {
    console.log(event.target.value);
    // const option = document.getElementsByClassName("option");
    // console.log("options=======", option);
    setSelectedLang(event.target.value);
  };
  const handleOnClick = (event) => {
    console.log(event.target.value);
    const option = document.getElementsByClassName("option");
    for (let i = 0; i < option.length; i++) {
      console.log("options=======", option[i].innerHTML);
      // if(option[i])
      if (option[i].innerHTML === "ENG") {
        option[i].innerHTML = "ENG";
      }
      if (option[i].innerHTML === "RU") {
        option[i].innerHTML = "RU";
      }
      if (option[i].innerHTML === "VIE") {
        option[i].innerHTML = "VIE";
      }
    }
    // setSelectedLang(event.target.value);
  };

  const handleAbort = () => {
    const option = document.getElementsByClassName("option");
    for (let i = 0; i < option.length; i++) {
      console.log("options=======", option[i].innerHTML);
      // if(option[i])
      if (option[i].innerHTML === "ENG") {
        option[i].innerHTML = "ENG";
      }
      if (option[i].innerHTML === "RU") {
        option[i].innerHTML = "RU";
      }
      if (option[i].innerHTML === "VIE") {
        option[i].innerHTML = "VIE";
      }
    }
  };

  const handleDisconnect = () => {
    dispatch(handleLogout());
  };

  const enterKeyDown = (e) => {
    if (e.keyCode === 13) {
      if (connectKeyStore_password.length > 0) {
        if (fileKeyStore?.name) connectKeyStoreFunction();
      }
    }
  };

  const enterKeyDownNewPswd = (e) => {
    if (e.keyCode === 13) {
      if (password.length < 1) {
        setPasswordEmptyError(true);
      } else {
        if (password != confirmPassword) {
          setPasswordMatchError(true);
        } else {
          setPasswordMatchError(false);
          submitKeyStore();
        }
      }
    }
  };

  // Send id of transactions to mark them as Read in the backend
  const handleNotificationsDropdown = () => {
    // nData
    // ?.reverse()
    // ?.slice(0, 3)
    // ?.map((e) =>
    setNotificationPopup(!notificationPopup);
    let notData = nData;
    console.log("><><>< SENDING IDS <><> ", notData?.slice(0, 3));
    const extractTID = notData
      // ?.reverse()
      ?.slice(0, 3)
      ?.map((e) => e._id);

    const data = {
      transactionIds: extractTID,
    };

    console.log("TID >>><<<<>>>>> ", data);

    axios
      .post(`${NGROK}/update/isvisited`, data)
      .then((res) => {
        // dispatch({
        //   type: SET_SETTINGS,
        //   payload: {
        //     settings: {
        //       custom: res?.data?.user?.custom,
        //       slip: res?.data?.user?.slip,
        //       speed: res?.data?.user?.speed,
        //     },
        //   },
        // });

        console.log(
          "RESSSSS =<><><><<ISVISITED><><><><><><<><><><>>< ",
          res?.data
        );
        getNotificationsData();
      })
      .catch((e) => console.log("ERR GETTING NOTIFICATIONS ><<>", e));
  };

  const gettingStatusJSX = () => {
    if (statusType === Enum.successfull) {
      console.log("Status========", statusType);

      return (
        <>
          <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="mr-3"
          >
            <rect y="0.0351562" width="20" height="20" rx="10" fill="#58BD7D" />
            <path
              d="M7 10.0352L9 12.0352L13 8.03516"
              stroke="#FCFCFD"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </>
      );
    } else if (statusType === Enum.pending) {
      console.log("Status========", statusType);

      return (
        <>
          <div
            class="spinner-border"
            style={{
              height: "12.5px",
              width: "12.5px",
              marginRight: "8px",
              marginBottom: "3px",
            }}
            role="status"
          ></div>
        </>
      );
    } else if (statusType === Enum.unsuccessfull) {
      console.log("Status========", statusType);
      return (
        <>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="mr-3"
          >
            <rect y="0.0351562" width="20" height="20" rx="10" fill="#FF6838" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.64645 6.6816C6.84171 6.48634 7.15829 6.48634 7.35355 6.6816L10 9.32805L12.6464 6.6816C12.8417 6.48634 13.1583 6.48634 13.3536 6.6816C13.5488 6.87686 13.5488 7.19345 13.3536 7.38871L10.7071 10.0352L13.3536 12.6816C13.5488 12.8769 13.5488 13.1934 13.3536 13.3887C13.1583 13.584 12.8417 13.584 12.6464 13.3887L10 10.7423L7.35355 13.3887C7.15829 13.584 6.84171 13.584 6.64645 13.3887C6.45118 13.1934 6.45118 12.8769 6.64645 12.6816L9.29289 10.0352L6.64645 7.38871C6.45118 7.19345 6.45118 6.87687 6.64645 6.6816Z"
              fill="#FCFCFD"
            />
          </svg>
        </>
      );
    }
  };

  return (
    <div style={{ backgroundColor: "#fcfcfd" }} class="n-navbarContainer">
      {/* 365 - 384 */}
      {/* Popup Modal Start*/}
      {transactionHistoryModalState && (
        <div class="n-swapProcess">
          <div class="n-swapProcessContent">
            <p>Transcation Status</p>
            <div class="text-center n-swappingData">
              {/* success */}

              {swappingData ? (
                <>
                  <div class="n-swapFromTo">
                    {gettingStatusJSX()}
                    <span className="ml-3">
                      {swappingData?.type} {swappingData?.fromAmount}{" "}
                      {swappingData?.fromAsset?.asset} for{" "}
                      {swappingData?.toAmount} {swappingData?.toAsset?.asset}
                    </span>
                  </div>
                  <div class="n-swapFromTo d-flex flex-row justify-content-between">
                    <span>
                      <svg
                        width="20"
                        height="21"
                        viewBox="0 0 20 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="mr-3"
                      >
                        <rect
                          y="0.0351562"
                          width="20"
                          height="20"
                          rx="10"
                          fill="#58BD7D"
                        />
                        <path
                          d="M7 10.0352L9 12.0352L13 8.03516"
                          stroke="#FCFCFD"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Send {swappingData?.fromAmount}{" "}
                      {swappingData?.fromAsset?.asset}
                    </span>
                    <i
                      onClick={() => {
                        window.open(`${swappingData?.viewblock}`);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                        <polyline points="15 3 21 3 21 9"></polyline>
                        <line x1="10" y1="14" x2="21" y2="3"></line>
                      </svg>
                    </i>
                  </div>
                  <div class="n-swapReceived d-flex flex-row justify-content-start">
                    {gettingStatusJSX()}
                    <span className="ml-3">
                      Receive {swappingData?.toAmount}{" "}
                      {swappingData?.toAsset?.asset}
                    </span>
                  </div>
                </>
              ) : null}
            </div>
          </div>
        </div>
      )}
      {/* Popup Modal End */}
      {/* <!-- Create KeyStore Modal  --> */}
      <Modal
        show={createKeyStoreModal}
        onHide={() => {
          setCreateKeyStoreModal(false);
        }}
        // backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          {/* <!-- Modal --> */}
          <div
            id="exampleModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
          >
            <div>
              <div class="modal-body">
                <div class="d-flex justify-content-between">
                  <div class="d-flex">
                    {/* <img
                      className="backArrow"
                      style={{
                        height: "10px",
                        marginTop: "15px",
                        paddingRight: "12px",
                      }}
                      src={Images.lefttwoline}
                      onClick={() => {
                        setCreateKeyStoreModal(false);
                        setSelectionModal(true);
                        // setMainModel(true);
                      }}
                    /> */}
                    <svg
                      className="backArrow mr-2"
                      width="32"
                      height="33"
                      viewBox="0 0 32 33"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      onClick={() => {
                        setCreateKeyStoreModal(false);
                        setSelectionModal(true);
                      }}
                      style={{
                        marginTop: "3px",
                      }}
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M13.2108 10.1876C12.6697 9.68812 11.8261 9.72186 11.3267 10.2629L7.01897 14.9296C6.5475 15.4403 6.5475 16.2276 7.01896 16.7383L11.3267 21.405C11.8261 21.9461 12.6697 21.9799 13.2108 21.4804C13.7519 20.9809 13.7856 20.1374 13.2861 19.5963L11.044 17.1673L23.9987 17.1673C24.7351 17.1673 25.332 16.5703 25.332 15.8339C25.332 15.0976 24.7351 14.5006 23.9987 14.5006L11.044 14.5006L13.2861 12.0717C13.7856 11.5306 13.7519 10.6871 13.2108 10.1876Z"
                        fill="#777E91"
                      />
                    </svg>
                    <p class="yahparagraph">Create Keystore</p>
                  </div>

                  <div>
                    {/* <img
                      className="popupcrosss"
                      onClick={() => {
                        setCreateKeyStoreModal(false);
                      }}
                      src={Images.crossicon}
                    /> */}
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="n-modalCloseIcon"
                      onClick={() => {
                        setCreateKeyStoreModal(false);
                      }}
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M13.2929 13.2929C13.6834 12.9024 14.3166 12.9024 14.7071 13.2929L20 18.5858L25.2929 13.2929C25.6834 12.9024 26.3166 12.9024 26.7071 13.2929C27.0976 13.6834 27.0976 14.3166 26.7071 14.7071L21.4142 20L26.7071 25.2929C27.0976 25.6834 27.0976 26.3166 26.7071 26.7071C26.3166 27.0976 25.6834 27.0976 25.2929 26.7071L20 21.4142L14.7071 26.7071C14.3166 27.0976 13.6834 27.0976 13.2929 26.7071C12.9024 26.3166 12.9024 25.6834 13.2929 25.2929L18.5858 20L13.2929 14.7071C12.9024 14.3166 12.9024 13.6834 13.2929 13.2929Z"
                        fill="#23262F"
                      />
                      <rect
                        x="1"
                        y="1"
                        width="38"
                        height="38"
                        rx="19"
                        stroke="#E6E8EC"
                        stroke-width="2"
                      />
                    </svg>
                  </div>
                </div>
                <div>
                  <div
                    style={{ marginTop: "32px", fontFamily: "Poppins" }}
                    class="form-group"
                  >
                    <label for="pwd" style={{ color: "#777e90" }}>
                      Input Password
                    </label>
                    <input
                      autoComplete="new-password"
                      type="password"
                      value={password}
                      onChange={(e) => {
                        setPassword(e.target.value);
                      }}
                      placeholder="Enter Password"
                      class="form-control n-connectModalInput"
                      onFocus={() => setPasswordEmptyError(false)}
                      onBlur={() =>
                        password.length < 1
                          ? setPasswordEmptyError(true)
                          : setPasswordEmptyError(false)
                      }
                    />
                    {passwordEmptyError && (
                      <div
                        style={{
                          fontSize: "10px",
                          marginLeft: "14px",
                          color: "red",
                        }}
                      >
                        Password is required
                      </div>
                    )}
                  </div>
                  <div
                    style={{ marginTop: "32px", fontFamily: "Poppins" }}
                    class="form-group"
                  >
                    <label for="pwd" style={{ color: "#777e90" }}>
                      Confirm Password
                    </label>
                    <input
                      autoComplete="new-password"
                      type="password"
                      value={confirmPassword}
                      placeholder="Confirm Password"
                      class="form-control n-connectModalInput"
                      onChange={(e) => {
                        setConfirmPassword(e.target.value);
                      }}
                      onFocus={() => setPasswordMatchError(false)}
                      onBlur={() =>
                        password != confirmPassword
                          ? setPasswordMatchError(true)
                          : setPasswordMatchError(false)
                      }
                      onKeyDown={enterKeyDownNewPswd}
                    />
                    {passwordMatchError && (
                      <div
                        style={{
                          fontSize: "10px",
                          marginLeft: "14px",
                          color: "red",
                        }}
                      >
                        Passwords do not match
                      </div>
                    )}
                  </div>
                  <div
                    style={{ marginTop: "32px", display: "grid" }}
                    className="display-grid justify-content"
                  >
                    <button
                      className="btn btn n-primaryButton n-primaryDark"
                      onClick={submitKeyStore}
                    >
                      Create
                    </button>
                    {/* <button
                      className="btn btn n-secondaryButton mt-3"
                      onClick={connectKeyStore}
                    >
                      Connect Wallet
                    </button> */}
                  </div>
                  {/* <button type="submit" class="btn btn-primary ml-2">
                        Connect Wallet
                      </button> */}
                </div>
              </div>
            </div>
          </div>
          {/* <!-- modal end --> */}
        </Modal.Body>
      </Modal>
      {/* <!-- Create KeyStore Modal END  --> */}

      {/* <!-- Connect KeyStore Modal  --> */}
      <Modal
        show={connectKeyStoreModal}
        onHide={() => {
          if (loading) {
            setConnectKeyStoreModal(false);
            window.location.reload();
          } else {
            setConnectKeyStoreModal(false);
          }
        }}
        // backdrop="static"
        keyboard={false}
      >
        <>
          {/* <!-- Modal --> */}
          <div
            id="exampleModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
          >
            <div class="modal-body">
              <div>
                <div class="modal-body">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex">
                      {/* <img
                        className="backArrow"
                        style={{
                          height: "10px",
                          marginTop: "15px",
                          paddingRight: "12px",
                        }}
                        src={Images.lefttwoline}
                        onClick={() => {
                          if (loading) {
                            setConnectKeyStoreModal(false);
                            window.location.reload();
                          } else {
                            setConnectKeyStoreModal(false);
                            setSelectionModal(true);
                          }
                        }}
                      /> */}
                      {/* <svg
                        className="backArrow mr-2"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={() => {
                          if (loading) {
                            setConnectKeyStoreModal(false);
                            window.location.reload();
                          } else {
                            setConnectKeyStoreModal(false);
                            setSelectionModal(true);
                          }
                        }}
                        style={{
                          marginTop: "2px",
                        }}
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M18.9428 10.3905C19.4635 10.9112 19.4635 11.7554 18.9428 12.2761L15.219 16L18.9428 19.7239C19.4635 20.2446 19.4635 21.0888 18.9428 21.6095C18.4221 22.1302 17.5779 22.1302 17.0572 21.6095L12.3905 16.9428C11.8698 16.4221 11.8698 15.5779 12.3905 15.0572L17.0572 10.3905C17.5779 9.86983 18.4221 9.86983 18.9428 10.3905Z"
                          fill="#23262F"
                        />
                      </svg> */}
                      <svg
                        className="backArrow mr-2"
                        width="32"
                        height="33"
                        viewBox="0 0 32 33"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={() => {
                          if (loading) {
                            setConnectKeyStoreModal(false);
                            window.location.reload();
                          } else {
                            setConnectKeyStoreModal(false);
                            setSelectionModal(true);
                          }
                        }}
                        style={{
                          marginTop: "3px",
                        }}
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M13.2108 10.1876C12.6697 9.68812 11.8261 9.72186 11.3267 10.2629L7.01897 14.9296C6.5475 15.4403 6.5475 16.2276 7.01896 16.7383L11.3267 21.405C11.8261 21.9461 12.6697 21.9799 13.2108 21.4804C13.7519 20.9809 13.7856 20.1374 13.2861 19.5963L11.044 17.1673L23.9987 17.1673C24.7351 17.1673 25.332 16.5703 25.332 15.8339C25.332 15.0976 24.7351 14.5006 23.9987 14.5006L11.044 14.5006L13.2861 12.0717C13.7856 11.5306 13.7519 10.6871 13.2108 10.1876Z"
                          fill="#777E91"
                        />
                      </svg>
                      <p class="yahparagraph">Connect Keystore</p>
                    </div>
                    <div>
                      {/* <img
                        className="popupcrosss"
                        onClick={() => {
                          if (loading) {
                            setConnectKeyStoreModal(false);
                            window.location.reload();
                          } else {
                            setConnectKeyStoreModal(false);
                          }
                        }}
                        src={Images.crossicon}
                      /> */}
                      <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="n-modalCloseIcon"
                        onClick={() => {
                          if (loading) {
                            setConnectKeyStoreModal(false);
                            window.location.reload();
                          } else {
                            setConnectKeyStoreModal(false);
                          }
                        }}
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M13.2929 13.2929C13.6834 12.9024 14.3166 12.9024 14.7071 13.2929L20 18.5858L25.2929 13.2929C25.6834 12.9024 26.3166 12.9024 26.7071 13.2929C27.0976 13.6834 27.0976 14.3166 26.7071 14.7071L21.4142 20L26.7071 25.2929C27.0976 25.6834 27.0976 26.3166 26.7071 26.7071C26.3166 27.0976 25.6834 27.0976 25.2929 26.7071L20 21.4142L14.7071 26.7071C14.3166 27.0976 13.6834 27.0976 13.2929 26.7071C12.9024 26.3166 12.9024 25.6834 13.2929 25.2929L18.5858 20L13.2929 14.7071C12.9024 14.3166 12.9024 13.6834 13.2929 13.2929Z"
                          fill="#23262F"
                        />
                        <rect
                          x="1"
                          y="1"
                          width="38"
                          height="38"
                          rx="19"
                          stroke="#E6E8EC"
                          stroke-width="2"
                        />
                      </svg>
                    </div>
                  </div>
                  <div>
                    <div
                      style={{ marginTop: "32px", fontFamily: "Poppins" }}
                      class="form-group"
                    >
                      {/*file Input*/}
                      <label for="file" style={{ color: "#777e90" }}>
                        Please Select Keystore File
                      </label>
                      <div>
                        {/* style={{ borderRadius: "26px !important", border: "2px solid #3772ff !important"}} */}
                        <Button
                          className="n-primaryButton n-primaryDark"
                          onClick={handleClick}
                          style={{
                            // border: "2px solid #3772ff",
                            borderRadius: "26px !important",
                          }}
                        >
                          Choose File
                        </Button>
                        <input
                          ref={hiddenFileInput}
                          style={{ display: "none" }}
                          type="file"
                          accept=".txt"
                          placeholder="choose filesss"
                          onChange={(e) => {
                            setFileKeyStore(e.target.files[0]);
                          }}
                        />
                        <label style={{ marginLeft: "4px", color: "#777e90" }}>
                          {fileKeyStore.name
                            ? fileKeyStore.name
                            : "No file chosen"}
                        </label>
                      </div>
                    </div>
                    <div
                      style={{ marginTop: "32px", fontFamily: "Poppins" }}
                      class="form-group"
                    >
                      <label for="pwd" style={{ color: "#777e90" }}>
                        Decryption password
                      </label>
                      <input
                        type="password"
                        value={connectKeyStore_password}
                        onChange={(e) => {
                          setConnectKeyStore_password(e.target.value);
                        }}
                        placeholder="Password"
                        class="form-control n-connectModalInput"
                        onKeyDown={enterKeyDown}
                      />
                    </div>
                    <div
                      style={{ marginTop: "32px" }}
                      class="d-flex justify-content"
                    >
                      <button
                        style={{ width: "100%" }}
                        disabled={loading}
                        className={`btn ${
                          loading
                            ? "btn n-primaryButtonDisabled"
                            : "btn n-primaryButton"
                        } n-primaryDark`}
                        onClick={
                          connectKeyStore_password.length > 0
                            ? fileKeyStore?.name
                              ? connectKeyStoreFunction
                              : null
                            : null
                        }
                      >
                        Connect
                        {loading ? (
                          <div
                            class="spinner-border"
                            style={{
                              height: "12.5px",
                              width: "12.5px",
                              marginLeft: "8px",
                              marginBottom: "2px",
                            }}
                            role="status"
                          ></div>
                        ) : null}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- modal end --> */}
        </>
      </Modal>
      {/* <!-- Connect KeyStore Modal END  --> */}

      {/* <!-- Main Modal  --> */}

      <Modal
        show={mainModal}
        onHide={() => {
          setMainModel(false);
        }}
        // backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          {/* <!-- Main Modal  --> */}
          <div
            id="exampleModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
            style={{
              paddingLeft: "20px",
              paddingRight: "20px",
              paddingBottom: "20px",
            }}
          >
            <div role="document">
              <div class="">
                <div class="modal-header" style={{ border: "none" }}>
                  <h5
                    class="modal-title n-modalHeader"
                    id="exampleModalLabel"
                    style={{
                      // color: "#23262F",
                      fontFamily: "DM Sans",
                      fontWeight: "bold",
                      fontSize: "32px",
                    }}
                  >
                    Connect wallet
                  </h5>
                  {/* <button
                    type="button"
                    class="close"
                    aria-label="Close"
                    onClick={() => {
                      setMainModel(false);
                    }}
                  >
                    <span className="popupcrosss" aria-hidden="true">
                      &times;
                    </span>
                  </button> */}
                  {/* <img
                    className="popupcrosss"
                    onClick={() => {
                      setMainModel(false);
                    }}
                    src={Images.crossicon}
                  /> */}
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="n-modalCloseIcon"
                    onClick={() => {
                      setMainModel(false);
                    }}
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M13.2929 13.2929C13.6834 12.9024 14.3166 12.9024 14.7071 13.2929L20 18.5858L25.2929 13.2929C25.6834 12.9024 26.3166 12.9024 26.7071 13.2929C27.0976 13.6834 27.0976 14.3166 26.7071 14.7071L21.4142 20L26.7071 25.2929C27.0976 25.6834 27.0976 26.3166 26.7071 26.7071C26.3166 27.0976 25.6834 27.0976 25.2929 26.7071L20 21.4142L14.7071 26.7071C14.3166 27.0976 13.6834 27.0976 13.2929 26.7071C12.9024 26.3166 12.9024 25.6834 13.2929 25.2929L18.5858 20L13.2929 14.7071C12.9024 14.3166 12.9024 13.6834 13.2929 13.2929Z"
                      fill="#23262F"
                    />
                    <rect
                      x="1"
                      y="1"
                      width="38"
                      height="38"
                      rx="19"
                      stroke="#E6E8EC"
                      stroke-width="2"
                    />
                  </svg>
                </div>
                <div class="modal-body">
                  <div class="d-flex justify-content-center modalparagraph mb-3">
                    <p
                      style={{
                        color: "#777E90",
                        fontSize: "14px",
                        fontWeight: "400",
                        fontFamily: "Poppins",
                        textAlign: "center",
                        marginBottom: "0px",
                      }}
                    >
                      To use our platform you will need to connect a wallet.
                      Please choose one of the listed.
                    </p>
                  </div>
                  <h5
                    style={{
                      fontSize: "12px",
                      color: "#B1B5C3",
                      fontWeight: "400",
                      fontFamily: "Poppins",
                      paddingBottom: "10px",
                      paddingTop: "10px",
                    }}
                  >
                    CHOOSE WALLET
                  </h5>
                  <button
                    class="d-flex justify-content-between connectwallet btnHoverWhite mt-3 mb-3"
                    style={{ width: "100%", background: "none" }}
                    onClick={connectXdefi}
                  >
                    <div class="d-flex">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="2.39999"
                          y="2.40002"
                          width="19.2"
                          height="19.2"
                          rx="9.6"
                          fill="url(#paint0_linear_4905_106381)"
                        />
                        <path
                          d="M13.2352 12.7154C12.174 13.3823 10.7541 13.7259 9.31562 13.6524C8.10599 13.5925 7.11429 13.1522 6.51467 12.4287C5.98753 11.7816 5.7832 10.9279 5.92148 9.94559C5.96848 9.61906 6.06446 9.30218 6.2067 9.00509L6.22649 8.96354C7.60111 6.28405 10.6628 4.97027 13.5214 5.83235C16.3807 6.69492 18.2322 9.49018 17.9342 12.494C17.6361 15.4983 15.2722 17.8651 12.3009 18.1347L12.3671 18.9001C15.7032 18.5993 18.3579 15.9423 18.6921 12.5692C19.0263 9.19631 16.9457 6.05845 13.7348 5.09346C10.524 4.12823 7.08881 5.60749 5.54944 8.61846L5.52297 8.67337C5.34671 9.04226 5.22784 9.43591 5.17047 9.8407C5.00572 11.038 5.26101 12.1034 5.92841 12.9239C6.65814 13.8209 7.84625 14.3544 9.27134 14.4244C11.0061 14.513 12.7313 14.0343 13.9553 13.154L13.2354 12.7154H13.2352Z"
                          fill="white"
                        />
                        <path
                          d="M14.8219 13.7053C14.1298 14.2723 12.5209 15.3004 9.85179 15.4406C6.86358 15.5965 5.61834 14.6804 5.60696 14.6713L5.36553 14.9516L5.60844 14.6757L5.12112 15.2274C5.17406 15.2694 6.36811 16.179 9.17302 16.179C9.40233 16.179 9.64351 16.179 9.89459 16.1602C13.1205 15.9905 14.8929 14.6634 15.5106 14.0964L14.8219 13.7053Z"
                          fill="white"
                        />
                        <path
                          d="M16.082 14.4539C15.6665 14.9844 15.1582 15.4351 14.5817 15.784C12.5409 17.0654 9.94505 17.2311 8.12788 17.1418L8.08954 17.8896C8.38386 17.9037 8.67848 17.9107 8.97314 17.9107C14.0981 17.9107 16.1691 15.6398 16.7474 14.8287L16.0805 14.4475"
                          fill="white"
                        />
                        <path
                          d="M15.8816 11.479C16.2232 11.479 16.5001 11.2022 16.5001 10.8606C16.5001 10.5191 16.2232 10.2422 15.8816 10.2422C15.5401 10.2422 15.2632 10.5191 15.2632 10.8606C15.2632 11.2022 15.5401 11.479 15.8816 11.479Z"
                          fill="white"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_4905_106381"
                            x1="5.69999"
                            y1="4.65002"
                            x2="17.55"
                            y2="23.1"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#1F40E0" />
                            <stop offset="1" stop-color="#0F1B59" />
                          </linearGradient>
                        </defs>
                      </svg>
                      <a
                        class="n-walletType"
                        style={{
                          // color: "#23262F",
                          fontSize: "14px",
                          fontFamily: "Poppins",
                          paddingLeft: "10px",
                          fontWeight: "600",
                        }}
                      >
                        XDEFI WALLET
                      </a>
                    </div>
                    {loading ? (
                      <div
                        class="spinner-border"
                        style={{
                          height: "20px",
                          width: "20px",
                          // marginLeft: "10px",
                          marginRight: "10px",
                        }}
                        role="status"
                      ></div>
                    ) : (
                      <div class="d-flex flex-row align-center-center">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ marginRight: "10px", marginTop: "2px" }}
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M7.31952 5.32544C6.89349 5.75935 6.89349 6.46287 7.31952 6.89679L10.3663 10L7.31952 13.1032C6.89349 13.5372 6.89349 14.2407 7.31952 14.6745C7.74555 15.1085 8.43627 15.1085 8.86228 14.6745L12.6805 10.7857C13.1065 10.3518 13.1065 9.64825 12.6805 9.21434L8.86228 5.32544C8.43627 4.89152 7.74555 4.89152 7.31952 5.32544Z"
                            fill="#777E91"
                          />
                        </svg>
                      </div>
                    )}
                  </button>
                  <button
                    class="d-flex justify-content-between connectwallet btnHoverWhite"
                    style={{ width: "100%", background: "none" }}
                    onClick={connectWalletConnect}
                  >
                    <div class="d-flex flex-row align-items-center">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.33293 8.69904C9.46307 5.63368 14.5369 5.63368 17.6711 8.69904L18.0477 9.06753C18.2056 9.22141 18.2056 9.46842 18.0477 9.62229L16.76 10.8857C16.6831 10.9626 16.5535 10.9626 16.4766 10.8857L15.9582 10.3795C13.7756 8.24147 10.2325 8.24147 8.04985 10.3795L7.49509 10.9221C7.41815 10.9991 7.28857 10.9991 7.21164 10.9221L5.91989 9.65874C5.76197 9.50486 5.76197 9.25785 5.91989 9.10398L6.33293 8.69904ZM20.3356 11.3068L21.4815 12.4285C21.6395 12.5824 21.6395 12.8294 21.4815 12.9833L16.3105 18.049C16.1526 18.2029 15.9015 18.2029 15.7436 18.049L12.0709 14.4532C12.0304 14.4167 11.9696 14.4167 11.9291 14.4532L8.26042 18.049C8.10249 18.2029 7.85143 18.2029 7.69351 18.049L2.51844 12.9873C2.36051 12.8334 2.36051 12.5864 2.51844 12.4325L3.6644 11.3109C3.82233 11.157 4.07339 11.157 4.23131 11.3109L7.90407 14.9067C7.94457 14.9431 8.00531 14.9431 8.0458 14.9067L11.7145 11.3109C11.8724 11.157 12.1235 11.157 12.2814 11.3109L15.9542 14.9067C15.9947 14.9431 16.0554 14.9431 16.0959 14.9067L19.7687 11.3109C19.9225 11.1529 20.1777 11.1529 20.3356 11.3068Z"
                          fill="#3A99FB"
                        />
                      </svg>
                      <a
                        class="n-walletType"
                        style={{
                          // color: "#23262F",
                          fontSize: "14px",
                          fontFamily: "Poppins",
                          paddingLeft: "10px",
                          fontWeight: "600",
                        }}
                      >
                        WALLETCONNECT
                      </a>
                    </div>
                    <div class="d-flex flex-row align-items-center">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ marginRight: "10px", marginTop: "2px" }}
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M7.31952 5.32544C6.89349 5.75935 6.89349 6.46287 7.31952 6.89679L10.3663 10L7.31952 13.1032C6.89349 13.5372 6.89349 14.2407 7.31952 14.6745C7.74555 15.1085 8.43627 15.1085 8.86228 14.6745L12.6805 10.7857C13.1065 10.3518 13.1065 9.64825 12.6805 9.21434L8.86228 5.32544C8.43627 4.89152 7.74555 4.89152 7.31952 5.32544Z"
                          fill="#777E91"
                        />
                      </svg>
                    </div>
                  </button>
                  <button
                    class="d-flex justify-content-between connectwallet btnHoverWhite mt-3"
                    style={{
                      width: "100%",
                      background: "none",
                    }}
                    onClick={xdfiExtension ? null : connectMetaMask}
                  >
                    <div class="d-flex flex-row align-center-center">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20.6505 2.40002L13.15 8.40002L14.5447 4.86403L20.6505 2.40002Z"
                          fill="#E17726"
                          stroke="#E17726"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M3.34958 2.40002L10.7833 8.45602L9.45533 4.86402L3.34958 2.40002Z"
                          fill="#E27625"
                          stroke="#E27625"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M17.9498 16.312L15.9541 19.608L20.2274 20.88L21.4515 16.3841L17.9498 16.312Z"
                          fill="#E27625"
                          stroke="#E27625"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M2.55573 16.3841L3.77241 20.88L8.03828 19.608L6.05001 16.312L2.55573 16.3841Z"
                          fill="#E27625"
                          stroke="#E27625"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M7.80825 10.744L6.62125 12.68L10.85 12.888L10.7091 7.96802L7.80825 10.744Z"
                          fill="#E27625"
                          stroke="#E27625"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M16.1915 10.7441L13.2463 7.91211L13.1498 12.8881L17.3785 12.6801L16.1915 10.7441Z"
                          fill="#E27625"
                          stroke="#E27625"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8.03833 19.608L10.5978 18.272L8.39445 16.416L8.03833 19.608Z"
                          fill="#E27625"
                          stroke="#E27625"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M13.4022 18.272L15.9542 19.608L15.6055 16.416L13.4022 18.272Z"
                          fill="#E27625"
                          stroke="#E27625"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.9542 19.6081L13.4022 18.2721L13.6099 20.0641L13.5876 20.8241L15.9542 19.6081Z"
                          fill="#D5BFB2"
                          stroke="#D5BFB2"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8.03833 19.6081L10.4124 20.8241L10.3975 20.0641L10.5978 18.2721L8.03833 19.6081Z"
                          fill="#D5BFB2"
                          stroke="#D5BFB2"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M10.4568 15.232L8.33502 14.5601L9.83363 13.816L10.4568 15.232Z"
                          fill="#233447"
                          stroke="#233447"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M13.5431 15.232L14.1663 13.816L15.6724 14.5601L13.5431 15.232Z"
                          fill="#233447"
                          stroke="#233447"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8.03829 19.608L8.40925 16.312L6.05005 16.3841L8.03829 19.608Z"
                          fill="#CC6228"
                          stroke="#CC6228"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.5906 16.312L15.9542 19.608L17.9498 16.3841L15.5906 16.312Z"
                          fill="#CC6228"
                          stroke="#CC6228"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M17.3785 12.6801L13.1498 12.8881L13.543 15.2321L14.1662 13.8161L15.6722 14.5601L17.3785 12.6801Z"
                          fill="#CC6228"
                          stroke="#CC6228"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8.335 14.5601L9.8336 13.8161L10.4568 15.2321L10.85 12.8881L6.62125 12.6801L8.335 14.5601Z"
                          fill="#CC6228"
                          stroke="#CC6228"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M6.6214 12.6801L8.39452 16.4161L8.33513 14.5601L6.6214 12.6801Z"
                          fill="#E27525"
                          stroke="#E27525"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.6724 14.5601L15.6056 16.4161L17.3787 12.6801L15.6724 14.5601Z"
                          fill="#E27525"
                          stroke="#E27525"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M10.8502 12.8881L10.457 15.2321L10.9541 18.0001L11.0654 14.3521L10.8502 12.8881Z"
                          fill="#E27525"
                          stroke="#E27525"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M13.1499 12.8881L12.9422 14.3441L13.046 18.0001L13.5431 15.2321L13.1499 12.8881Z"
                          fill="#E27525"
                          stroke="#E27525"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M13.5431 15.2321L13.0461 18L13.4022 18.2721L15.6056 16.4161L15.6723 14.5601L13.5431 15.2321Z"
                          fill="#F5841F"
                          stroke="#F5841F"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8.33502 14.5601L8.39441 16.4161L10.5978 18.2721L10.9539 18L10.4568 15.2321L8.33502 14.5601Z"
                          fill="#F5841F"
                          stroke="#F5841F"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M13.5877 20.824L13.6099 20.064L13.417 19.888H10.583L10.3975 20.064L10.4124 20.824L8.03833 19.608L8.86924 20.344L10.5533 21.6H13.4392L15.1307 20.344L15.9542 19.608L13.5877 20.824Z"
                          fill="#C0AC9D"
                          stroke="#C0AC9D"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M13.4021 18.272L13.046 18H10.9539L10.5978 18.272L10.3975 20.064L10.583 19.888H13.417L13.6099 20.064L13.4021 18.272Z"
                          fill="#161616"
                          stroke="#161616"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M20.9694 8.792L21.6 5.48002L20.6504 2.40002L13.4022 8.20005L16.1916 10.744L20.131 11.984L20.9991 10.888L20.6207 10.592L21.2216 10.0001L20.7617 9.61604L21.3626 9.12002L20.9694 8.792Z"
                          fill="#763E1A"
                          stroke="#763E1A"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M2.39999 5.48002L3.03802 8.792L2.62998 9.12002L3.23833 9.61604L2.77836 10.0001L3.37928 10.592L3.00092 10.888L3.86893 11.984L7.80837 10.744L10.5978 8.20005L3.34961 2.40002L2.39999 5.48002Z"
                          fill="#763E1A"
                          stroke="#763E1A"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M20.1311 11.984L16.1917 10.744L17.3787 12.68L15.6056 16.416L17.95 16.384H21.4517L20.1311 11.984Z"
                          fill="#F5841F"
                          stroke="#F5841F"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M7.80825 10.744L3.86886 11.984L2.55573 16.384H6.05001L8.39434 16.416L6.62126 12.68L7.80825 10.744Z"
                          fill="#F5841F"
                          stroke="#F5841F"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M13.1499 12.888L13.4021 8.19998L14.5446 4.86401H9.45529L10.5978 8.19998L10.85 12.888L10.9465 14.36L10.9539 18H13.046L13.0534 14.36L13.1499 12.888Z"
                          fill="#F5841F"
                          stroke="#F5841F"
                          stroke-width="0.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <a
                        class="n-walletType"
                        style={{
                          // color: "#23262F",
                          fontSize: "14px",
                          fontFamily: "Poppins",
                          paddingLeft: "10px",
                          fontWeight: "600",
                        }}
                      >
                        {xdfiExtension
                          ? "DISABLE XDEFI WALLET"
                          : "METAMASK WALLET"}
                      </a>
                    </div>
                    <div class="d-flex flex-row align-center-center">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ marginRight: "10px", marginTop: "2px" }}
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M7.31952 5.32544C6.89349 5.75935 6.89349 6.46287 7.31952 6.89679L10.3663 10L7.31952 13.1032C6.89349 13.5372 6.89349 14.2407 7.31952 14.6745C7.74555 15.1085 8.43627 15.1085 8.86228 14.6745L12.6805 10.7857C13.1065 10.3518 13.1065 9.64825 12.6805 9.21434L8.86228 5.32544C8.43627 4.89152 7.74555 4.89152 7.31952 5.32544Z"
                          fill="#777E91"
                        />
                      </svg>
                    </div>
                  </button>

                  <button
                    class="d-flex justify-content-between connectwallet btnHoverWhite mt-3 mb-3"
                    style={{ width: "100%", background: "none" }}
                    onClick={() => {
                      setMainModel(false);
                      setSelectionModal(true);
                    }}
                  >
                    {" "}
                    <a
                      class="n-walletType"
                      style={{
                        // color: "#23262F",
                        fontSize: "14px",
                        fontFamily: "Poppins",
                        fontWeight: "600",
                        lineHeight: "24px",
                      }}
                    >
                      CUSTOM KEYSTORE
                    </a>
                    <div class="d-flex flex-row align-center-center">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ marginRight: "10px", marginTop: "2px" }}
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M7.31952 5.32544C6.89349 5.75935 6.89349 6.46287 7.31952 6.89679L10.3663 10L7.31952 13.1032C6.89349 13.5372 6.89349 14.2407 7.31952 14.6745C7.74555 15.1085 8.43627 15.1085 8.86228 14.6745L12.6805 10.7857C13.1065 10.3518 13.1065 9.64825 12.6805 9.21434L8.86228 5.32544C8.43627 4.89152 7.74555 4.89152 7.31952 5.32544Z"
                          fill="#777E91"
                        />
                      </svg>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- modal end --> */}
        </Modal.Body>
      </Modal>

      {/* <!-- Selection Modal  --> */}

      <Modal
        show={selectionModal}
        onHide={() => {
          setSelectionModal(false);
        }}
        // backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          {/* <!-- Main Modal  --> */}
          <div
            id="exampleModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div role="document">
              <div class="">
                <div class="modal-body">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex">
                      {/* <img
                        className="backArrow"
                        style={{
                          height: "10px",
                          marginTop: "15px",
                          paddingRight: "12px",
                        }}
                        src={Images.lefttwoline}
                        onClick={() => {
                          setSelectionModal(false);
                          setMainModel(true);
                        }}
                      /> */}
                      {/* <svg
                        className="backArrow mr-2"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={() => {
                          setSelectionModal(false);
                          setMainModel(true);
                        }}
                        style={{
                          marginTop: "2px",
                        }}
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M18.9428 10.3905C19.4635 10.9112 19.4635 11.7554 18.9428 12.2761L15.219 16L18.9428 19.7239C19.4635 20.2446 19.4635 21.0888 18.9428 21.6095C18.4221 22.1302 17.5779 22.1302 17.0572 21.6095L12.3905 16.9428C11.8698 16.4221 11.8698 15.5779 12.3905 15.0572L17.0572 10.3905C17.5779 9.86983 18.4221 9.86983 18.9428 10.3905Z"
                          fill="#23262F"
                        />
                      </svg> */}
                      <svg
                        className="backArrow mr-2"
                        width="32"
                        height="33"
                        viewBox="0 0 32 33"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={() => {
                          setSelectionModal(false);
                          setMainModel(true);
                        }}
                        style={{
                          marginTop: "3px",
                        }}
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M13.2108 10.1876C12.6697 9.68812 11.8261 9.72186 11.3267 10.2629L7.01897 14.9296C6.5475 15.4403 6.5475 16.2276 7.01896 16.7383L11.3267 21.405C11.8261 21.9461 12.6697 21.9799 13.2108 21.4804C13.7519 20.9809 13.7856 20.1374 13.2861 19.5963L11.044 17.1673L23.9987 17.1673C24.7351 17.1673 25.332 16.5703 25.332 15.8339C25.332 15.0976 24.7351 14.5006 23.9987 14.5006L11.044 14.5006L13.2861 12.0717C13.7856 11.5306 13.7519 10.6871 13.2108 10.1876Z"
                          fill="#777E91"
                        />
                      </svg>
                      <p class="yahparagraph">Select</p>
                    </div>
                    <div>
                      {/* <img
                        className="popupcrosss"
                        onClick={() => {
                          setSelectionModal(false);
                        }}
                        src={Images.crossicon}
                      /> */}
                      <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="n-modalCloseIcon"
                        onClick={() => {
                          setSelectionModal(false);
                        }}
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M13.2929 13.2929C13.6834 12.9024 14.3166 12.9024 14.7071 13.2929L20 18.5858L25.2929 13.2929C25.6834 12.9024 26.3166 12.9024 26.7071 13.2929C27.0976 13.6834 27.0976 14.3166 26.7071 14.7071L21.4142 20L26.7071 25.2929C27.0976 25.6834 27.0976 26.3166 26.7071 26.7071C26.3166 27.0976 25.6834 27.0976 25.2929 26.7071L20 21.4142L14.7071 26.7071C14.3166 27.0976 13.6834 27.0976 13.2929 26.7071C12.9024 26.3166 12.9024 25.6834 13.2929 25.2929L18.5858 20L13.2929 14.7071C12.9024 14.3166 12.9024 13.6834 13.2929 13.2929Z"
                          fill="#23262F"
                        />
                        <rect
                          x="1"
                          y="1"
                          width="38"
                          height="38"
                          rx="19"
                          stroke="#E6E8EC"
                          stroke-width="2"
                        />
                      </svg>
                    </div>
                  </div>
                  <div
                    style={{ marginTop: "32px" }}
                    class="d-flex justify-content"
                  >
                    <p style={{ color: "#777E90", fontWeight: "600" }}>
                      Please choose one of the listed.
                    </p>
                  </div>
                  <h5
                    style={{
                      fontSize: "12px",
                      color: "#B1B5C3",
                      marginTop: "32px",
                      marginBottom: "32px",
                      fontFamily: "Poppins",
                      fontWeight: "400",
                    }}
                  >
                    CHOOSE WALLET
                  </h5>
                  <button
                    class="d-flex justify-content-between connectwallet btnHoverWhite"
                    style={{
                      width: "100%",
                      background: "none",
                      marginBottom: "16px",
                    }}
                    onClick={() => {
                      setSelectionModal(false);
                      setCreateKeyStoreModal(true);
                    }}
                  >
                    <div class="d-flex">
                      <a
                        class="n-walletType"
                        style={{
                          // color: "#23262F",
                          fontSize: "14px",
                          paddingLeft: "5px",
                          fontFamily: "Poppins",
                          fontWeight: "600",
                        }}
                      >
                        Create KeyStore
                      </a>
                    </div>
                    {/* <img
                      style={{
                        width: "16px",
                        height: "15px",
                        paddingTop: "8px",
                        paddingRight: "10px",
                      }}
                      src={Images.moreright}
                    /> */}
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ marginRight: "10px", marginTop: "0px" }}
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.31952 5.32544C6.89349 5.75935 6.89349 6.46287 7.31952 6.89679L10.3663 10L7.31952 13.1032C6.89349 13.5372 6.89349 14.2407 7.31952 14.6745C7.74555 15.1085 8.43627 15.1085 8.86228 14.6745L12.6805 10.7857C13.1065 10.3518 13.1065 9.64825 12.6805 9.21434L8.86228 5.32544C8.43627 4.89152 7.74555 4.89152 7.31952 5.32544Z"
                        fill="#777E91"
                      />
                    </svg>
                  </button>
                  <button
                    class="d-flex justify-content-between connectwallet btnHoverWhite"
                    style={{ width: "100%", background: "none" }}
                    onClick={() => {
                      setSelectionModal(false);
                      setConnectKeyStoreModal(true);
                    }}
                  >
                    <div class="d-flex">
                      <a
                        class="n-walletType"
                        style={{
                          // color: "#23262F",
                          fontSize: "14px",
                          fontFamily: "Poppins",
                          paddingLeft: "10px",
                          fontWeight: "600",
                        }}
                      >
                        Connect KeyStore
                      </a>
                    </div>

                    {/* <img
                      style={{
                        width: "16px",
                        height: "15px",
                        paddingTop: "8px",
                        paddingRight: "10px",
                      }}
                      src={Images.moreright}
                    /> */}
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ marginRight: "10px", marginTop: "0px" }}
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.31952 5.32544C6.89349 5.75935 6.89349 6.46287 7.31952 6.89679L10.3663 10L7.31952 13.1032C6.89349 13.5372 6.89349 14.2407 7.31952 14.6745C7.74555 15.1085 8.43627 15.1085 8.86228 14.6745L12.6805 10.7857C13.1065 10.3518 13.1065 9.64825 12.6805 9.21434L8.86228 5.32544C8.43627 4.89152 7.74555 4.89152 7.31952 5.32544Z"
                        fill="#777E91"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- modal end --> */}
        </Modal.Body>
      </Modal>

      <div class="container n-navbarContainer" style={{ padding: "0px" }}>
        <nav
          class="navbar navbar-expand-lg navbar-light"
          style={{
            backgroundColor: "#fcfcfd",
            // height: "80px",
            padding: "20px 0px",
            margin: "0px 15px",
          }}
        >
          <Link
            className="navbar-brand"
            to={browserRoute.HOME}
            // style={{ marginRight: "0px", borderRight: "1px solid #E6E8EC" }}
            class="n-defiLogo"
          >
            <img src={Images.newdefilogo} alt="DefiSpot" height="15px" />
            {/* <svg
              width="75"
              height="15"
              viewBox="0 0 75 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ width: "140px", height: "auto" }}
            >
              <g clip-path="url(#clip0_301_41)">
                <path
                  d="M0.594 11.978C0.594 10.97 0.792 10.076 1.188 9.296C1.596 8.516 2.148 7.916 2.844 7.496C3.54 7.076 4.314 6.866 5.166 6.866C5.814 6.866 6.432 7.01 7.02 7.298C7.608 7.574 8.076 7.946 8.424 8.414V3.68H10.98V17H8.424V15.524C8.112 16.016 7.674 16.412 7.11 16.712C6.546 17.012 5.892 17.162 5.148 17.162C4.308 17.162 3.54 16.946 2.844 16.514C2.148 16.082 1.596 15.476 1.188 14.696C0.792 13.904 0.594 12.998 0.594 11.978ZM8.442 12.014C8.442 11.402 8.322 10.88 8.082 10.448C7.842 10.004 7.518 9.668 7.11 9.44C6.702 9.2 6.264 9.08 5.796 9.08C5.328 9.08 4.896 9.194 4.5 9.422C4.104 9.65 3.78 9.986 3.528 10.43C3.288 10.862 3.168 11.378 3.168 11.978C3.168 12.578 3.288 13.106 3.528 13.562C3.78 14.006 4.104 14.348 4.5 14.588C4.908 14.828 5.34 14.948 5.796 14.948C6.264 14.948 6.702 14.834 7.11 14.606C7.518 14.366 7.842 14.03 8.082 13.598C8.322 13.154 8.442 12.626 8.442 12.014ZM22.7112 11.798C22.7112 12.158 22.6872 12.482 22.6392 12.77H15.3492C15.4092 13.49 15.6612 14.054 16.1052 14.462C16.5492 14.87 17.0952 15.074 17.7432 15.074C18.6792 15.074 19.3452 14.672 19.7412 13.868H22.4592C22.1712 14.828 21.6192 15.62 20.8032 16.244C19.9872 16.856 18.9852 17.162 17.7972 17.162C16.8372 17.162 15.9732 16.952 15.2052 16.532C14.4492 16.1 13.8552 15.494 13.4232 14.714C13.0032 13.934 12.7932 13.034 12.7932 12.014C12.7932 10.982 13.0032 10.076 13.4232 9.296C13.8432 8.516 14.4312 7.916 15.1872 7.496C15.9432 7.076 16.8132 6.866 17.7972 6.866C18.7452 6.866 19.5912 7.07 20.3352 7.478C21.0912 7.886 21.6732 8.468 22.0812 9.224C22.5012 9.968 22.7112 10.826 22.7112 11.798ZM20.1012 11.078C20.0892 10.43 19.8552 9.914 19.3992 9.53C18.9432 9.134 18.3852 8.936 17.7252 8.936C17.1012 8.936 16.5732 9.128 16.1412 9.512C15.7212 9.884 15.4632 10.406 15.3672 11.078H20.1012ZM29.1226 9.098H27.3766V17H24.8206V9.098H23.6866V7.028H24.8206V6.524C24.8206 5.3 25.1686 4.4 25.8646 3.824C26.5606 3.248 27.6106 2.978 29.0146 3.014V5.138C28.4026 5.126 27.9766 5.228 27.7366 5.444C27.4966 5.66 27.3766 6.05 27.3766 6.614V7.028H29.1226V9.098ZM32.0337 5.84C31.5897 5.84 31.2177 5.702 30.9177 5.426C30.6297 5.138 30.4857 4.784 30.4857 4.364C30.4857 3.944 30.6297 3.596 30.9177 3.32C31.2177 3.032 31.5897 2.888 32.0337 2.888C32.4777 2.888 32.8437 3.032 33.1317 3.32C33.4317 3.596 33.5817 3.944 33.5817 4.364C33.5817 4.784 33.4317 5.138 33.1317 5.426C32.8437 5.702 32.4777 5.84 32.0337 5.84ZM33.2757 7.028V17H30.7557V7.028H33.2757ZM39.5814 17.162C38.7654 17.162 38.0334 17.018 37.3854 16.73C36.7374 16.43 36.2214 16.028 35.8374 15.524C35.4654 15.02 35.2614 14.462 35.2254 13.85H37.7634C37.8114 14.234 37.9974 14.552 38.3214 14.804C38.6574 15.056 39.0714 15.182 39.5634 15.182C40.0434 15.182 40.4154 15.086 40.6794 14.894C40.9554 14.702 41.0934 14.456 41.0934 14.156C41.0934 13.832 40.9254 13.592 40.5894 13.436C40.2654 13.268 39.7434 13.088 39.0234 12.896C38.2794 12.716 37.6674 12.53 37.1874 12.338C36.7194 12.146 36.3114 11.852 35.9634 11.456C35.6274 11.06 35.4594 10.526 35.4594 9.854C35.4594 9.302 35.6154 8.798 35.9274 8.342C36.2514 7.886 36.7074 7.526 37.2954 7.262C37.8954 6.998 38.5974 6.866 39.4014 6.866C40.5894 6.866 41.5374 7.166 42.2454 7.766C42.9534 8.354 43.3434 9.152 43.4154 10.16H41.0034C40.9674 9.764 40.7994 9.452 40.4994 9.224C40.2114 8.984 39.8214 8.864 39.3294 8.864C38.8734 8.864 38.5194 8.948 38.2674 9.116C38.0274 9.284 37.9074 9.518 37.9074 9.818C37.9074 10.154 38.0754 10.412 38.4114 10.592C38.7474 10.76 39.2694 10.934 39.9774 11.114C40.6974 11.294 41.2914 11.48 41.7594 11.672C42.2274 11.864 42.6294 12.164 42.9654 12.572C43.3134 12.968 43.4934 13.496 43.5054 14.156C43.5054 14.732 43.3434 15.248 43.0194 15.704C42.7074 16.16 42.2514 16.52 41.6514 16.784C41.0634 17.036 40.3734 17.162 39.5814 17.162ZM48.094 8.468C48.418 8.012 48.862 7.634 49.426 7.334C50.002 7.022 50.656 6.866 51.388 6.866C52.24 6.866 53.008 7.076 53.692 7.496C54.388 7.916 54.934 8.516 55.33 9.296C55.738 10.064 55.942 10.958 55.942 11.978C55.942 12.998 55.738 13.904 55.33 14.696C54.934 15.476 54.388 16.082 53.692 16.514C53.008 16.946 52.24 17.162 51.388 17.162C50.656 17.162 50.008 17.012 49.444 16.712C48.892 16.412 48.442 16.034 48.094 15.578V21.752H45.574V7.028H48.094V8.468ZM53.368 11.978C53.368 11.378 53.242 10.862 52.99 10.43C52.75 9.986 52.426 9.65 52.018 9.422C51.622 9.194 51.19 9.08 50.722 9.08C50.266 9.08 49.834 9.2 49.426 9.44C49.03 9.668 48.706 10.004 48.454 10.448C48.214 10.892 48.094 11.414 48.094 12.014C48.094 12.614 48.214 13.136 48.454 13.58C48.706 14.024 49.03 14.366 49.426 14.606C49.834 14.834 50.266 14.948 50.722 14.948C51.19 14.948 51.622 14.828 52.018 14.588C52.426 14.348 52.75 14.006 52.99 13.562C53.242 13.118 53.368 12.59 53.368 11.978ZM62.2013 17.162C61.2413 17.162 60.3773 16.952 59.6093 16.532C58.8413 16.1 58.2353 15.494 57.7913 14.714C57.3593 13.934 57.1433 13.034 57.1433 12.014C57.1433 10.994 57.3653 10.094 57.8093 9.314C58.2653 8.534 58.8833 7.934 59.6633 7.514C60.4433 7.082 61.3133 6.866 62.2733 6.866C63.2333 6.866 64.1033 7.082 64.8833 7.514C65.6633 7.934 66.2753 8.534 66.7193 9.314C67.1753 10.094 67.4033 10.994 67.4033 12.014C67.4033 13.034 67.1693 13.934 66.7012 14.714C66.2453 15.494 65.6213 16.1 64.8293 16.532C64.0493 16.952 63.1733 17.162 62.2013 17.162ZM62.2013 14.966C62.6573 14.966 63.0833 14.858 63.4793 14.642C63.8873 14.414 64.2113 14.078 64.4513 13.634C64.6913 13.19 64.8113 12.65 64.8113 12.014C64.8113 11.066 64.5593 10.34 64.0553 9.836C63.5633 9.32 62.9573 9.062 62.2373 9.062C61.5173 9.062 60.9113 9.32 60.4193 9.836C59.9393 10.34 59.6993 11.066 59.6993 12.014C59.6993 12.962 59.9333 13.694 60.4013 14.21C60.8813 14.714 61.4813 14.966 62.2013 14.966ZM72.1858 9.098V13.922C72.1858 14.258 72.2638 14.504 72.4198 14.66C72.5878 14.804 72.8638 14.876 73.2478 14.876H74.4178V17H72.8338C70.7098 17 69.6478 15.968 69.6478 13.904V9.098H68.4598V7.028H69.6478V4.562H72.1858V7.028H74.4178V9.098H72.1858Z"
                  fill="#0052FF"
                />
              </g>
              <defs>
                <clipPath id="clip0_301_41">
                  <rect width="75" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg> */}
          </Link>
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            {/* <span class="navbar-toggler-icon"></span> */}
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.66683 10.667C5.93045 10.667 5.3335 11.2639 5.3335 12.0003C5.3335 12.7367 5.93045 13.3337 6.66683 13.3337H25.3335C26.0699 13.3337 26.6668 12.7367 26.6668 12.0003C26.6668 11.2639 26.0699 10.667 25.3335 10.667H6.66683Z"
                fill="#777E91"
              />
              <path
                d="M6.66683 18.667C5.93045 18.667 5.3335 19.2639 5.3335 20.0003C5.3335 20.7367 5.93045 21.3337 6.66683 21.3337H25.3335C26.0699 21.3337 26.6668 20.7367 26.6668 20.0003C26.6668 19.2639 26.0699 18.667 25.3335 18.667H6.66683Z"
                fill="#777E91"
              />
            </svg>
          </button>

          <div
            class="collapse navbar-collapse"
            id="navbarSupportedContent"
            style={{ height: "40px" }}
          >
            <ul class="navbar-nav mr-auto n-navbarNav">
              <li className="nav-item d-flex flex-row align-items-center">
                <Link
                  to={browserRoute.MARKET}
                  className={
                    "nav-link " +
                    (window.location.href.indexOf(browserRoute.MARKET) !== -1
                      ? "active"
                      : null)
                  }
                >
                  Market
                </Link>
              </li>
              <li class="nav-item">
                <Link
                  to={browserRoute.EARNYIELD}
                  className={
                    "nav-link " +
                    (window.location.href.indexOf(browserRoute.EARNYIELD) !== -1
                      ? "active"
                      : null)
                  }
                >
                  Earn yield
                </Link>
              </li>
              <li class="nav-item">
                <Link
                  to={browserRoute.PORTFOLIO}
                  className={
                    "nav-link " +
                    (window.location.href.indexOf(browserRoute.PORTFOLIO) !== -1
                      ? "active"
                      : null)
                  }
                >
                  Portfolio
                </Link>
              </li>
              <li class="nav-item w-nav-web">
                <div class="n-menuLearnLink">
                  <Link
                    // to={browserRoute.LEARN}
                    to="#"
                    className={
                      "nav-link nn-learnDropDown" +
                      (window.location.href.indexOf(browserRoute.LEARN) !== -1
                        ? "active"
                        : null)
                    }
                  >
                    <span>
                      <Link className="learn-menuItem" to={browserRoute.LEARN}>
                        Learn
                      </Link>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-header-learn-arrow"
                        ref={myRefLearn}
                        onClick={() => setLearnDropDown(!learnDropDown)}
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M10.8047 6.5286C10.5444 6.26825 10.1223 6.26825 9.86193 6.5286L8 8.39052L6.13807 6.52859C5.87772 6.26825 5.45561 6.26825 5.19526 6.52859C4.93491 6.78894 4.93491 7.21105 5.19526 7.4714L7.5286 9.80474C7.78894 10.0651 8.21105 10.0651 8.4714 9.80474L10.8047 7.4714C11.0651 7.21105 11.0651 6.78894 10.8047 6.5286Z"
                          fill="#777E91"
                        />
                      </svg>
                    </span>
                    {/* <img
                      ref={myRefLearn}
                      onClick={() => setLearnDropDown(!learnDropDown)}
                      className="w-header-learn-arrow"
                      // src={headerdown}
                      src={Images.iconarowdown}
                    /> */}
                    {/* <div class="n-learnDropDownCap">
                      <img src={Images.cap} />
                    </div> */}
                    {
                      <div className="n-learnMainDropDown">
                        <span class="triangle1"></span>
                        <ul class="n-learnDropDown" role="menu">
                          <li>
                            <a href="">Tutorial</a>
                          </li>
                          <hr />
                          <li>
                            <a href="">Liquidity Providing</a>
                          </li>
                          <hr />
                          <li>
                            <a href="">Trading</a>
                          </li>
                          <hr />
                          <li>
                            <a href="">Wallet</a>
                          </li>
                        </ul>
                      </div>
                    }
                  </Link>
                </div>
              </li>
              <li class="nav-item dropdown w-nav-mob">
                <a
                  class="nav-link dropdown-toggle w-nav-drop"
                  href="#"
                  id="navbarDropdownMenuLink"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Learn
                </a>
                <div
                  class="dropdown-menu w-learnDropDown"
                  aria-labelledby="navbarDropdownMenuLink"
                >
                  <a class="dropdown-item" href="#">
                    Tutorial
                  </a>
                  <a class="dropdown-item" href="#">
                    Liquidity Providing
                  </a>
                  <a class="dropdown-item" href="#">
                    Trading
                  </a>
                  <a class="dropdown-item" href="#">
                    Wallet
                  </a>
                </div>
              </li>
            </ul>
            {/* <div class="n-languageSelect">
              <div
                onClick={() => setLanguageDropDown(!languageDropDown)}
                ref={myRefLanguage}
              >
                ENG
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ marginBottom: "2px" }}
                  className="n-languageArrow"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.8047 6.5286C10.5444 6.26825 10.1223 6.26825 9.86193 6.5286L8 8.39052L6.13807 6.52859C5.87772 6.26825 5.45561 6.26825 5.19526 6.52859C4.93491 6.78894 4.93491 7.21105 5.19526 7.4714L7.5286 9.80474C7.78894 10.0651 8.21105 10.0651 8.4714 9.80474L10.8047 7.4714C11.0651 7.21105 11.0651 6.78894 10.8047 6.5286Z"
                    fill="#777E91"
                  />
                </svg>
              </div>
              {languageDropDown && (
                <div className="n-languageMainDropDown">
                  <span class="triangle2"></span>
                  <ul class="n-languageDropDown" role="menu">
                    <li>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="mr-2"
                      >
                        <path
                          d="M0 12.6675C5.3325 15.4675 10.6675 9.86751 16 12.6675C16 12.4275 16 12.1875 16 11.95C10.6675 9.15001 5.3325 14.75 0 11.95C0 12.1875 0 12.4275 0 12.6675Z"
                          fill="#CA2027"
                        />
                        <path
                          d="M0 11.9501C5.3325 14.7501 10.6675 9.15011 16 11.9501C16 11.7101 16 11.4701 16 11.2326C10.6675 8.43261 5.3325 14.0326 0 11.2326C0 11.4701 0 11.7101 0 11.9501Z"
                          fill="white"
                        />
                        <path
                          d="M0 11.23C5.3325 14.03 10.6675 8.43001 16 11.23C16 10.99 16 10.7525 16 10.5125C10.6675 7.71251 5.3325 13.3125 0 10.5125C0 10.7525 0 10.9925 0 11.23Z"
                          fill="#CA2027"
                        />
                        <path
                          d="M0 10.5126C5.3325 13.3126 10.6675 7.71261 16 10.5126C16 10.2726 16 10.0351 16 9.79511C10.6675 6.99511 5.3325 12.5951 0 9.79511C0 10.0351 0 10.2751 0 10.5126Z"
                          fill="white"
                        />
                        <path
                          d="M0 9.79501C5.3325 12.595 10.6675 6.99501 16 9.79501C16 9.55501 16 9.31501 16 9.07501C10.6675 6.27501 5.3325 11.875 0 9.07501C0 9.31501 0 9.55751 0 9.79501Z"
                          fill="#CA2027"
                        />
                        <path
                          d="M0 9.07755C5.3325 11.8775 10.6675 6.27755 16 9.07755C16 8.83755 16 8.60005 16 8.36005C10.6675 5.56005 5.3325 11.16 0 8.36005C0 8.60005 0 8.83755 0 9.07755Z"
                          fill="white"
                        />
                        <path
                          d="M0 8.36008C5.3325 11.1601 10.6675 5.56008 16 8.36008C16 8.12008 16 7.88008 16 7.64008C10.6675 4.84008 5.3325 10.4401 0 7.64008C0 7.88008 0 8.12008 0 8.36008Z"
                          fill="#CA2027"
                        />
                        <path
                          d="M0 7.64005C5.3325 10.44 10.6675 4.84005 16 7.64005C16 7.40005 16 7.16255 16 6.92255C10.6675 4.12255 5.3325 9.72255 0 6.92255C0 7.16255 0 7.40255 0 7.64005Z"
                          fill="white"
                        />
                        <path
                          d="M0 6.92252C5.3325 9.72252 10.6675 4.12252 16 6.92252C16 6.68252 16 6.44502 16 6.20502C10.6675 3.40502 5.3325 9.00502 0 6.20502C0 6.44502 0 6.68252 0 6.92252Z"
                          fill="#CA2027"
                        />
                        <path
                          d="M0 6.20499C5.3325 9.00499 10.6675 3.40499 16 6.20499C16 5.96499 16 5.72499 16 5.48749C10.6675 2.68749 5.3325 8.28749 0 5.48749C0 5.72749 0 5.96749 0 6.20499Z"
                          fill="white"
                        />
                        <path
                          d="M0 5.48752C5.3325 8.28752 10.6675 2.68752 16 5.48752C16 5.24752 16 5.00752 16 4.76752C10.6675 1.96752 5.3325 7.56752 0 4.76752C0 5.00752 0 5.24752 0 5.48752Z"
                          fill="#CA2027"
                        />
                        <path
                          d="M0 4.77005C5.3325 7.57005 10.6675 1.97005 16 4.77005C16 4.53005 16 4.29255 16 4.05255C10.6675 1.25255 5.3325 6.85255 0 4.05255C0 4.29005 0 4.53005 0 4.77005Z"
                          fill="white"
                        />
                        <path
                          d="M0 4.05252C5.3325 6.85252 10.6675 1.25252 16 4.05252C16 3.81252 16 3.57252 16 3.33502C10.6675 0.535024 5.3325 6.13502 0 3.33502C0 3.57252 0 3.81252 0 4.05252Z"
                          fill="#CA2027"
                        />
                        <path
                          d="M0 8.36002C2.435 9.63752 4.87 9.16502 7.3075 8.54002C7.3075 6.86502 7.3075 5.19002 7.3075 3.51252C4.87 4.13752 2.435 4.61252 0 3.33252C0 5.00752 0 6.68502 0 8.36002Z"
                          fill="#2B3561"
                        />
                        <path
                          d="M0.659991 4.1925C0.679991 4.265 0.699991 4.335 0.722491 4.4075C0.787491 4.4325 0.854991 4.4575 0.922491 4.4825C0.867491 4.5025 0.814991 4.5225 0.762491 4.54C0.782491 4.61 0.802491 4.6825 0.822491 4.7525C0.767491 4.6925 0.714991 4.6325 0.659991 4.5725C0.604991 4.59 0.552491 4.6075 0.497491 4.6225C0.517491 4.5675 0.539991 4.5125 0.559991 4.46C0.504991 4.4 0.452491 4.3375 0.397491 4.2725C0.462491 4.3025 0.529991 4.33 0.594991 4.3575C0.617491 4.3025 0.637491 4.2475 0.659991 4.1925Z"
                          fill="white"
                        />
                        <path
                          d="M0.659991 5.03247C0.679991 5.10247 0.699991 5.17497 0.722491 5.24747C0.787491 5.27247 0.854991 5.29747 0.922491 5.32247C0.867491 5.34247 0.814991 5.36247 0.762491 5.37997C0.782491 5.45247 0.802491 5.52247 0.822491 5.59497C0.767491 5.53497 0.714991 5.47497 0.659991 5.41497C0.604991 5.43247 0.552491 5.44997 0.497491 5.46497C0.517491 5.40997 0.539991 5.35497 0.559991 5.29997C0.504991 5.23997 0.452491 5.17747 0.397491 5.11247C0.462491 5.14247 0.529991 5.16997 0.594991 5.19747C0.617491 5.13997 0.637491 5.08747 0.659991 5.03247Z"
                          fill="white"
                        />
                        <path
                          d="M0.659991 5.87C0.679991 5.9425 0.699991 6.0125 0.722491 6.085C0.787491 6.11 0.854991 6.135 0.922491 6.16C0.867491 6.18 0.814991 6.2 0.762491 6.2175C0.782491 6.2875 0.802491 6.36 0.822491 6.43C0.767491 6.37 0.712491 6.31 0.659991 6.25C0.604991 6.2675 0.552491 6.285 0.497491 6.3C0.517491 6.245 0.539991 6.19 0.559991 6.1375C0.504991 6.075 0.452491 6.015 0.397491 5.95C0.462491 5.98 0.529991 6.0075 0.594991 6.035C0.617491 5.98 0.637491 5.925 0.659991 5.87Z"
                          fill="white"
                        />
                        <path
                          d="M0.659991 6.71008C0.679991 6.78258 0.699991 6.85258 0.722491 6.92508C0.787491 6.95008 0.854991 6.97508 0.922491 7.00008C0.867491 7.02008 0.814991 7.04008 0.762491 7.06008C0.782491 7.13008 0.802491 7.20008 0.822491 7.27258C0.767491 7.21508 0.714991 7.15508 0.659991 7.09258C0.604991 7.11008 0.552491 7.12508 0.497491 7.14258C0.517491 7.08758 0.539991 7.03508 0.559991 6.98008C0.504991 6.91758 0.452491 6.85508 0.397491 6.79258C0.462491 6.82258 0.529991 6.85008 0.594991 6.87758C0.617491 6.81758 0.637491 6.76508 0.659991 6.71008Z"
                          fill="white"
                        />
                        <path
                          d="M0.659991 7.54761C0.679991 7.62011 0.699991 7.69011 0.722491 7.76261C0.787491 7.78761 0.854991 7.81261 0.922491 7.83761C0.867491 7.85761 0.814991 7.87511 0.762491 7.89511C0.782491 7.96511 0.802491 8.03761 0.822491 8.10761C0.767491 8.04761 0.714991 7.98761 0.659991 7.92761C0.604991 7.94511 0.552491 7.96261 0.497491 7.97761C0.517491 7.92261 0.539991 7.86761 0.559991 7.81511C0.504991 7.75261 0.452491 7.69011 0.397491 7.62761C0.462491 7.65761 0.529991 7.68511 0.594991 7.71261C0.617491 7.65761 0.637491 7.60261 0.659991 7.54761Z"
                          fill="white"
                        />
                        <path
                          d="M1.24251 4.83752C1.26251 4.90752 1.28251 4.97502 1.30251 5.04502C1.37001 5.06502 1.43501 5.08252 1.50251 5.10002C1.45001 5.12502 1.39501 5.15002 1.34251 5.17502C1.36251 5.24502 1.38251 5.31252 1.40251 5.38002C1.35001 5.32752 1.29501 5.27252 1.24251 5.21752C1.19001 5.24002 1.13501 5.26252 1.08251 5.28502C1.10251 5.22752 1.12251 5.17252 1.14251 5.11502C1.08751 5.06002 1.03501 5.00252 0.982513 4.94502C1.05001 4.96752 1.11501 4.99002 1.18251 5.01002C1.20251 4.95252 1.22251 4.89502 1.24251 4.83752Z"
                          fill="white"
                        />
                        <path
                          d="M1.24251 5.67749C1.26251 5.74499 1.28251 5.81499 1.30251 5.88499C1.37001 5.90499 1.43501 5.92249 1.50251 5.93999C1.45001 5.96499 1.39501 5.98999 1.34251 6.01499C1.36251 6.08499 1.38251 6.15249 1.40251 6.21999C1.35001 6.16749 1.29501 6.11249 1.24251 6.05749C1.19001 6.07999 1.13501 6.10249 1.08251 6.12249C1.10251 6.06749 1.12251 6.00999 1.14251 5.95249C1.08751 5.89749 1.03501 5.83999 0.982513 5.78249C1.05001 5.80499 1.11501 5.82749 1.18251 5.84749C1.20251 5.78999 1.22251 5.73499 1.24251 5.67749Z"
                          fill="white"
                        />
                        <path
                          d="M1.24251 6.51501C1.26251 6.58501 1.28251 6.65251 1.30251 6.72251C1.37001 6.74251 1.43501 6.76001 1.50251 6.77751C1.45001 6.80251 1.39501 6.82751 1.34251 6.85001C1.36251 6.92001 1.38251 6.98751 1.40251 7.05751C1.35001 7.00251 1.29501 6.95001 1.24251 6.89501C1.19001 6.91751 1.13501 6.94001 1.08251 6.96251C1.10251 6.90501 1.12251 6.84751 1.14251 6.79251C1.08751 6.73751 1.03501 6.68001 0.982513 6.62251C1.05001 6.64501 1.11501 6.66751 1.18251 6.68751C1.20251 6.63001 1.22251 6.57251 1.24251 6.51501Z"
                          fill="white"
                        />
                        <path
                          d="M1.24251 7.3551C1.26251 7.4226 1.28251 7.4926 1.30251 7.5626C1.37001 7.5826 1.43501 7.6001 1.50251 7.6176C1.45001 7.6426 1.39501 7.6676 1.34251 7.6926C1.36251 7.7626 1.38251 7.8301 1.40251 7.8976C1.35001 7.8451 1.29501 7.7901 1.24251 7.7351C1.19001 7.7576 1.13501 7.7801 1.08251 7.8026C1.10251 7.7451 1.12251 7.6901 1.14251 7.6326C1.08751 7.5776 1.03501 7.5201 0.982513 7.4626C1.05001 7.4851 1.11501 7.5076 1.18251 7.5276C1.20251 7.4701 1.22251 7.4126 1.24251 7.3551Z"
                          fill="white"
                        />
                        <path
                          d="M1.83498 4.54504C1.85498 4.61254 1.87748 4.68004 1.89748 4.74754C1.96498 4.76004 2.02998 4.77254 2.09748 4.78504C2.04248 4.81504 1.98998 4.84504 1.93498 4.87254C1.95498 4.94004 1.97748 5.00754 1.99748 5.07504C1.94248 5.02504 1.88748 4.97504 1.83248 4.92504C1.77748 4.95254 1.72498 4.98004 1.67248 5.00754C1.69248 4.95004 1.71248 4.89004 1.73248 4.83254C1.67998 4.78254 1.62498 4.73004 1.57248 4.67754C1.63748 4.69504 1.70498 4.71004 1.76998 4.72254C1.79248 4.66254 1.81248 4.60504 1.83498 4.54504Z"
                          fill="white"
                        />
                        <path
                          d="M1.83498 5.38501C1.85498 5.45251 1.87748 5.52001 1.89748 5.58751C1.96498 5.60001 2.02998 5.61251 2.09748 5.62501C2.04248 5.65501 1.98998 5.68251 1.93498 5.71251C1.95498 5.78001 1.97748 5.84751 1.99748 5.91501C1.94248 5.86501 1.88748 5.81501 1.83248 5.76501C1.77748 5.79251 1.72498 5.82001 1.67248 5.84751C1.69248 5.78751 1.71248 5.73001 1.73248 5.67001C1.67998 5.62001 1.62498 5.56751 1.57248 5.51751C1.63748 5.53251 1.70498 5.55001 1.76998 5.56251C1.79248 5.50251 1.81248 5.44251 1.83498 5.38501Z"
                          fill="white"
                        />
                        <path
                          d="M1.83498 6.22253C1.85498 6.29003 1.87748 6.35753 1.89748 6.42503C1.96498 6.43753 2.02998 6.45003 2.09748 6.46003C2.04248 6.49003 1.98998 6.52003 1.93498 6.54753C1.95498 6.61503 1.97748 6.68253 1.99748 6.75003C1.94248 6.70003 1.88748 6.65003 1.83248 6.60003C1.77748 6.62753 1.72498 6.65503 1.67248 6.68253C1.69248 6.62503 1.71248 6.56503 1.73248 6.50503C1.67998 6.45503 1.62498 6.40253 1.57248 6.35003C1.63748 6.36503 1.70498 6.38253 1.76998 6.39503C1.79248 6.34003 1.81248 6.28003 1.83498 6.22253Z"
                          fill="white"
                        />
                        <path
                          d="M1.83498 7.06006C1.85498 7.12756 1.87748 7.19506 1.89748 7.26256C1.96498 7.27506 2.02998 7.28756 2.09748 7.29756C2.04248 7.32756 1.98998 7.35756 1.93498 7.38506C1.95498 7.45256 1.97748 7.52006 1.99748 7.58506C1.94248 7.53756 1.88748 7.48756 1.83248 7.43756C1.77748 7.46506 1.72498 7.49256 1.67248 7.52006C1.69248 7.46256 1.71248 7.40256 1.73248 7.34506C1.67998 7.29506 1.62498 7.24256 1.57248 7.19006C1.63748 7.20506 1.70498 7.22256 1.76998 7.23506C1.79248 7.18006 1.81248 7.12006 1.83498 7.06006Z"
                          fill="white"
                        />
                        <path
                          d="M1.83498 7.90002C1.85498 7.96752 1.87748 8.03502 1.89748 8.10252C1.96498 8.11502 2.02998 8.12752 2.09748 8.13752C2.04248 8.16752 1.98998 8.19752 1.93498 8.22502C1.95498 8.29252 1.97748 8.36002 1.99748 8.42752C1.94248 8.37752 1.88748 8.32752 1.83248 8.27752C1.77748 8.30502 1.72498 8.33252 1.67248 8.36002C1.69248 8.30002 1.71248 8.24252 1.73248 8.18252C1.67998 8.13252 1.62498 8.08002 1.57248 8.02752C1.63748 8.04502 1.70498 8.06002 1.76998 8.07252C1.79248 8.01752 1.81248 7.96002 1.83498 7.90002Z"
                          fill="white"
                        />
                        <path
                          d="M2.42001 5.08008C2.44001 5.14508 2.46001 5.21258 2.48251 5.27758C2.55001 5.28508 2.61751 5.29258 2.68501 5.29758C2.63001 5.33258 2.57501 5.36758 2.52251 5.40008C2.54251 5.46508 2.56501 5.53008 2.58501 5.59508C2.53001 5.55008 2.47501 5.50508 2.42251 5.46008C2.36751 5.49258 2.31501 5.52508 2.26251 5.55508C2.28251 5.49508 2.30501 5.43508 2.32501 5.37508C2.27001 5.32758 2.21501 5.28008 2.16251 5.23258C2.23001 5.24258 2.29751 5.25258 2.36251 5.26258C2.38001 5.20258 2.40001 5.14258 2.42001 5.08008Z"
                          fill="white"
                        />
                        <path
                          d="M2.42001 5.92004C2.44001 5.98504 2.46001 6.05254 2.48251 6.11754C2.55001 6.12504 2.61751 6.13254 2.68501 6.13754C2.63001 6.17254 2.57501 6.20504 2.52251 6.24004C2.54251 6.30504 2.56501 6.37004 2.58501 6.43504C2.53001 6.39004 2.47501 6.34504 2.42251 6.30004C2.36751 6.33254 2.31501 6.36504 2.26251 6.39504C2.28251 6.33504 2.30501 6.27504 2.32501 6.21504C2.27001 6.16754 2.21501 6.12254 2.16251 6.07504C2.23001 6.08504 2.29751 6.09504 2.36251 6.10254C2.38001 6.04254 2.40001 5.98254 2.42001 5.92004Z"
                          fill="white"
                        />
                        <path
                          d="M2.42001 6.76001C2.44001 6.82501 2.46001 6.89251 2.48251 6.95751C2.55001 6.96501 2.61751 6.97251 2.68501 6.97751C2.63001 7.01251 2.57501 7.04501 2.52251 7.08001C2.54251 7.14501 2.56501 7.21001 2.58501 7.27751C2.53001 7.23251 2.47501 7.18751 2.42251 7.14251C2.36751 7.17501 2.31501 7.20751 2.26251 7.23751C2.28251 7.17751 2.30501 7.11751 2.32501 7.05501C2.27001 7.00751 2.21501 6.96251 2.16251 6.91501C2.23001 6.92501 2.29751 6.93501 2.36251 6.94251C2.38001 6.88001 2.40001 6.82001 2.42001 6.76001Z"
                          fill="white"
                        />
                        <path
                          d="M2.42001 7.59753C2.44001 7.66253 2.46001 7.73003 2.48251 7.79503C2.55001 7.80253 2.61751 7.81003 2.68501 7.81503C2.63001 7.85003 2.57501 7.88253 2.52251 7.91753C2.54251 7.98253 2.56501 8.04753 2.58501 8.11253C2.53001 8.06753 2.47501 8.02253 2.42251 7.97753C2.36751 8.01003 2.31501 8.04253 2.26251 8.07253C2.28251 8.01253 2.30501 7.95253 2.32501 7.89253C2.27001 7.84503 2.21501 7.80003 2.16251 7.75253C2.23001 7.76253 2.29751 7.77253 2.36251 7.78003C2.38001 7.72003 2.40001 7.66003 2.42001 7.59753Z"
                          fill="white"
                        />
                        <path
                          d="M3.01 4.6875C3.03 4.7525 3.0525 4.8175 3.075 4.88C3.14 4.8825 3.2075 4.885 3.2725 4.885C3.2175 4.9225 3.165 4.9625 3.11 4.9975C3.13 5.0625 3.1525 5.125 3.175 5.19C3.12 5.15 3.065 5.1075 3.0125 5.0675C2.9575 5.105 2.905 5.14 2.8525 5.1775C2.8725 5.115 2.8925 5.0525 2.9125 4.9925C2.86 4.95 2.805 4.9075 2.7525 4.865C2.8175 4.87 2.885 4.875 2.95 4.8775C2.97 4.8125 2.99 4.75 3.01 4.6875Z"
                          fill="white"
                        />
                        <path
                          d="M3.01 5.52747C3.03 5.59247 3.0525 5.65497 3.075 5.71997C3.14 5.72247 3.2075 5.72497 3.2725 5.72497C3.2175 5.76247 3.165 5.79997 3.11 5.83747C3.13 5.90247 3.1525 5.96497 3.175 6.02997C3.12 5.98997 3.065 5.94747 3.0125 5.90747C2.9575 5.94497 2.905 5.97997 2.8525 6.01747C2.8725 5.95497 2.8925 5.89247 2.9125 5.82997C2.86 5.78747 2.805 5.74497 2.7525 5.70247C2.8175 5.70747 2.885 5.71247 2.95 5.71497C2.97 5.65247 2.99 5.58997 3.01 5.52747Z"
                          fill="white"
                        />
                        <path
                          d="M3.01 6.36499C3.03 6.42999 3.0525 6.49499 3.075 6.55749C3.14 6.55999 3.2075 6.56249 3.2725 6.56249C3.2175 6.59999 3.165 6.63749 3.11 6.67499C3.13 6.73999 3.1525 6.80249 3.175 6.86749C3.12 6.82749 3.065 6.78499 3.0125 6.74499C2.9575 6.78249 2.905 6.81749 2.8525 6.85499C2.8725 6.79249 2.8925 6.72999 2.9125 6.66749C2.86 6.62499 2.805 6.58249 2.7525 6.53999C2.8175 6.54499 2.885 6.54999 2.95 6.55249C2.97 6.48999 2.99 6.42749 3.01 6.36499Z"
                          fill="white"
                        />
                        <path
                          d="M3.01 7.20508C3.03 7.27008 3.0525 7.33258 3.075 7.39758C3.14 7.40008 3.2075 7.40008 3.2725 7.40258C3.2175 7.44008 3.165 7.48008 3.11 7.51758C3.13 7.58258 3.1525 7.64508 3.175 7.70758C3.12 7.66758 3.065 7.62758 3.0125 7.58508C2.9575 7.62258 2.905 7.65758 2.8525 7.69258C2.8725 7.63008 2.8925 7.57008 2.9125 7.50758C2.86 7.46508 2.805 7.42258 2.7525 7.38008C2.8175 7.38508 2.885 7.39008 2.95 7.39258C2.97 7.33008 2.99 7.26758 3.01 7.20508Z"
                          fill="white"
                        />
                        <path
                          d="M3.01 8.0426C3.03 8.1076 3.0525 8.1701 3.075 8.2351C3.14 8.2376 3.2075 8.2401 3.2725 8.2401C3.2175 8.2776 3.165 8.3151 3.11 8.3526C3.13 8.4176 3.1525 8.4801 3.175 8.5451C3.12 8.5051 3.065 8.4626 3.0125 8.4226C2.9575 8.4601 2.905 8.4951 2.8525 8.5326C2.8725 8.4701 2.8925 8.4076 2.9125 8.3451C2.86 8.3026 2.805 8.2601 2.7525 8.2176C2.8175 8.2226 2.885 8.2276 2.95 8.2301C2.97 8.1676 2.99 8.1051 3.01 8.0426Z"
                          fill="white"
                        />
                        <path
                          d="M3.59749 5.13501C3.61749 5.19751 3.63749 5.26001 3.65749 5.32501C3.72499 5.32251 3.79249 5.32001 3.85749 5.31751C3.80249 5.36001 3.74999 5.40001 3.69499 5.44251C3.71499 5.50501 3.73499 5.56751 3.75499 5.63001C3.70249 5.59251 3.64749 5.55501 3.59499 5.51751C3.53999 5.55751 3.48749 5.59751 3.43249 5.63751C3.45249 5.57501 3.47249 5.51001 3.49249 5.44751C3.43749 5.41001 3.38499 5.37001 3.32999 5.33001C3.39749 5.33001 3.46249 5.33001 3.52999 5.33001C3.55499 5.26251 3.57499 5.20001 3.59749 5.13501Z"
                          fill="white"
                        />
                        <path
                          d="M3.59749 5.97498C3.61749 6.03748 3.63749 6.09998 3.65749 6.16248C3.72499 6.15998 3.79249 6.15748 3.85749 6.15498C3.80249 6.19748 3.74999 6.23748 3.69499 6.27998C3.71499 6.34248 3.73499 6.40498 3.75499 6.46748C3.70249 6.42998 3.64749 6.39498 3.59499 6.35748C3.53999 6.39748 3.48749 6.43748 3.43249 6.47748C3.45249 6.41498 3.47249 6.34998 3.49249 6.28748C3.43749 6.24998 3.38499 6.20998 3.32999 6.16998C3.39749 6.16998 3.46249 6.16998 3.52999 6.16748C3.55499 6.10248 3.57499 6.03748 3.59749 5.97498Z"
                          fill="white"
                        />
                        <path
                          d="M3.59749 6.8125C3.61749 6.875 3.63749 6.9375 3.65749 7C3.72499 6.9975 3.79249 6.995 3.85749 6.9925C3.80249 7.0325 3.74999 7.075 3.69499 7.115C3.71499 7.1775 3.73499 7.24 3.75499 7.3025C3.70249 7.265 3.64749 7.2275 3.59499 7.19C3.53999 7.23 3.48749 7.27 3.43249 7.31C3.45249 7.245 3.47249 7.1825 3.49249 7.12C3.43749 7.0825 3.38499 7.0425 3.32999 7.0025C3.39749 7.0025 3.46249 7.0025 3.52999 7.0025C3.55499 6.94 3.57499 6.8775 3.59749 6.8125Z"
                          fill="white"
                        />
                        <path
                          d="M3.59749 7.65247C3.61749 7.71497 3.63749 7.77747 3.65749 7.83997C3.72499 7.83747 3.79249 7.83497 3.85749 7.83247C3.80249 7.87497 3.74999 7.91497 3.69499 7.95747C3.71499 8.01997 3.73499 8.08247 3.75499 8.14497C3.70249 8.10747 3.64749 8.06997 3.59499 8.03247C3.53999 8.07247 3.48749 8.11247 3.43249 8.15247C3.45249 8.08997 3.47249 8.02497 3.49249 7.96247C3.43749 7.92497 3.38499 7.88497 3.32999 7.84497C3.39749 7.84497 3.46249 7.84497 3.52999 7.84247C3.55499 7.77997 3.57499 7.71497 3.59749 7.65247Z"
                          fill="white"
                        />
                        <path
                          d="M4.18749 4.66003C4.20749 4.72253 4.22999 4.78503 4.24999 4.84503C4.31749 4.84003 4.38249 4.83253 4.44999 4.82503C4.39499 4.87003 4.34249 4.91503 4.28749 4.95753C4.30749 5.01753 4.32999 5.08003 4.35249 5.14003C4.29749 5.10503 4.24249 5.07253 4.18999 5.03753C4.13499 5.08003 4.08249 5.12503 4.02999 5.16753C4.04999 5.10253 4.06999 5.03753 4.08999 4.97253C4.03749 4.93753 3.98249 4.90253 3.92999 4.86753C3.99499 4.86253 4.06249 4.86003 4.12999 4.85503C4.14499 4.79253 4.16749 4.72503 4.18749 4.66003Z"
                          fill="white"
                        />
                        <path
                          d="M4.18749 5.5C4.20749 5.56 4.22999 5.6225 4.24999 5.685C4.31749 5.68 4.38249 5.6725 4.44999 5.665C4.39499 5.71 4.34249 5.7525 4.28749 5.7975C4.30749 5.86 4.32999 5.92 4.35249 5.9825C4.29749 5.9475 4.24249 5.915 4.18999 5.88C4.13499 5.925 4.08249 5.9675 4.02999 6.01C4.04999 5.945 4.06999 5.88 4.08999 5.815C4.03749 5.78 3.98249 5.745 3.92999 5.71C3.99499 5.705 4.06249 5.7025 4.12999 5.695C4.14499 5.63 4.16749 5.565 4.18749 5.5Z"
                          fill="white"
                        />
                        <path
                          d="M4.18749 6.33752C4.20749 6.40002 4.22999 6.46002 4.24999 6.52252C4.31749 6.51752 4.38249 6.51002 4.44999 6.50252C4.39499 6.54752 4.34249 6.59002 4.28749 6.63502C4.30749 6.69752 4.32999 6.75752 4.35249 6.82002C4.29749 6.78502 4.24249 6.75252 4.18999 6.71752C4.13499 6.76002 4.08249 6.80502 4.02999 6.84752C4.04999 6.78252 4.06999 6.71752 4.08999 6.65252C4.03749 6.61752 3.98249 6.58252 3.92999 6.54752C3.99499 6.54252 4.06249 6.54002 4.12999 6.53252C4.14499 6.47002 4.16749 6.40502 4.18749 6.33752Z"
                          fill="white"
                        />
                        <path
                          d="M4.18749 7.17749C4.20749 7.23749 4.22999 7.29999 4.24999 7.36249C4.31749 7.35499 4.38249 7.34999 4.44999 7.34249C4.39499 7.38749 4.34249 7.43249 4.28749 7.47749C4.30749 7.53749 4.32999 7.59999 4.35249 7.65999C4.29749 7.62749 4.24249 7.59249 4.18999 7.55749C4.13499 7.59999 4.08249 7.64499 4.02999 7.68499C4.04999 7.61999 4.06999 7.55499 4.08999 7.49249C4.03749 7.45749 3.98249 7.42249 3.92999 7.38499C3.99499 7.37999 4.06249 7.37749 4.12999 7.36999C4.14499 7.30749 4.16749 7.24249 4.18749 7.17749Z"
                          fill="white"
                        />
                        <path
                          d="M4.18749 8.01758C4.20749 8.08008 4.22999 8.14008 4.24999 8.20258C4.31749 8.19758 4.38249 8.19008 4.44999 8.18258C4.39499 8.22758 4.34249 8.27258 4.28749 8.31508C4.30749 8.37758 4.32999 8.43758 4.35249 8.50008C4.29749 8.46508 4.24249 8.43258 4.18999 8.39758C4.13499 8.44008 4.08249 8.48508 4.02999 8.52758C4.04999 8.46258 4.06999 8.39758 4.08999 8.33258C4.03749 8.29758 3.98249 8.26258 3.92999 8.22758C3.99499 8.22258 4.06249 8.22008 4.12999 8.21508C4.14499 8.14758 4.16749 8.08258 4.18749 8.01758Z"
                          fill="white"
                        />
                        <path
                          d="M4.77001 5.03748C4.79001 5.09748 4.81251 5.15748 4.83251 5.21998C4.90001 5.20998 4.96501 5.19998 5.03501 5.18998C4.98001 5.23748 4.92751 5.28498 4.87251 5.33248C4.89251 5.39248 4.91251 5.45248 4.93501 5.51248C4.88001 5.47998 4.82751 5.44998 4.77251 5.41748C4.72001 5.46248 4.66501 5.50998 4.61251 5.55498C4.63251 5.48998 4.65501 5.42248 4.67501 5.35748C4.62001 5.32498 4.56751 5.29248 4.51251 5.25748C4.58001 5.24998 4.64501 5.24248 4.71251 5.23248C4.73001 5.16998 4.75001 5.10498 4.77001 5.03748Z"
                          fill="white"
                        />
                        <path
                          d="M4.77001 5.87744C4.79001 5.93744 4.81251 5.99744 4.83251 6.05994C4.90001 6.04994 4.96501 6.03994 5.03501 6.02994C4.98001 6.07744 4.92751 6.12494 4.87251 6.16994C4.89251 6.22994 4.91251 6.28994 4.93501 6.34994C4.88001 6.31994 4.82751 6.28744 4.77251 6.25744C4.72001 6.30244 4.66501 6.34994 4.61251 6.39494C4.63251 6.32994 4.65501 6.26244 4.67501 6.19744C4.62001 6.16494 4.56751 6.13244 4.51251 6.09994C4.58001 6.09244 4.64501 6.08494 4.71251 6.07494C4.73001 6.00994 4.75001 5.94494 4.77001 5.87744Z"
                          fill="white"
                        />
                        <path
                          d="M4.77001 6.71753C4.79001 6.77753 4.81251 6.83753 4.83251 6.89753C4.90001 6.88753 4.96501 6.87753 5.03501 6.86753C4.98001 6.91503 4.92751 6.96253 4.87251 7.00753C4.89251 7.06753 4.91251 7.12753 4.93501 7.19003C4.88001 7.15753 4.82751 7.12753 4.77251 7.09503C4.72001 7.14003 4.66501 7.18753 4.61251 7.23253C4.63251 7.16753 4.65501 7.10003 4.67501 7.03503C4.62001 7.00253 4.56751 6.97003 4.51251 6.93753C4.58001 6.93003 4.64501 6.92253 4.71251 6.91253C4.73001 6.85003 4.75001 6.78253 4.77001 6.71753Z"
                          fill="white"
                        />
                        <path
                          d="M4.77001 7.5575C4.79001 7.6175 4.81251 7.6775 4.83251 7.7375C4.90001 7.7275 4.96501 7.7175 5.03501 7.7075C4.98001 7.755 4.92751 7.8025 4.87251 7.85C4.89251 7.91 4.91251 7.96999 4.93501 8.02999C4.88001 7.99749 4.82751 7.9675 4.77251 7.935C4.72001 7.9825 4.66501 8.0275 4.61251 8.0725C4.63251 8.0075 4.65501 7.9425 4.67501 7.875C4.62001 7.8425 4.56751 7.81 4.51251 7.7775C4.58001 7.77 4.64501 7.7625 4.71251 7.7525C4.73001 7.6875 4.75001 7.6225 4.77001 7.5575Z"
                          fill="white"
                        />
                        <path
                          d="M5.36251 4.505C5.38251 4.565 5.40501 4.625 5.42501 4.685C5.49001 4.6725 5.55751 4.66 5.62251 4.6475C5.56751 4.6975 5.51501 4.745 5.46251 4.795C5.48251 4.855 5.50251 4.915 5.52501 4.975C5.47001 4.945 5.41751 4.9175 5.36251 4.8875C5.31001 4.935 5.25501 4.985 5.20251 5.0325C5.22251 4.965 5.24251 4.9 5.26251 4.8325C5.21001 4.8025 5.15501 4.7725 5.10251 4.7425C5.16751 4.7325 5.23501 4.72 5.30251 4.71C5.32251 4.6375 5.34251 4.5725 5.36251 4.505Z"
                          fill="white"
                        />
                        <path
                          d="M5.36251 5.34253C5.38251 5.40253 5.40501 5.46253 5.42501 5.52003C5.49001 5.50753 5.55751 5.49503 5.62251 5.48253C5.56751 5.53253 5.51501 5.58003 5.46251 5.63003C5.48251 5.69003 5.50251 5.75003 5.52501 5.81003C5.47001 5.78253 5.41751 5.75253 5.36251 5.72253C5.31001 5.77003 5.25501 5.82003 5.20251 5.86753C5.22251 5.80003 5.24251 5.73253 5.26251 5.66503C5.21001 5.63503 5.15501 5.60503 5.10251 5.57503C5.16751 5.56503 5.23501 5.55253 5.30251 5.54253C5.32251 5.47753 5.34251 5.41003 5.36251 5.34253Z"
                          fill="white"
                        />
                        <path
                          d="M5.36251 6.1825C5.38251 6.2425 5.40501 6.3025 5.42501 6.3625C5.49001 6.35 5.55751 6.3375 5.62251 6.325C5.56751 6.375 5.51501 6.425 5.46251 6.4725C5.48251 6.5325 5.50251 6.5925 5.52501 6.6525C5.47001 6.625 5.41751 6.595 5.36251 6.565C5.31001 6.6125 5.25501 6.6625 5.20251 6.71C5.22251 6.6425 5.24251 6.5775 5.26251 6.51C5.21001 6.48 5.15501 6.45 5.10251 6.42C5.16751 6.41 5.23501 6.3975 5.30251 6.3875C5.32251 6.315 5.34251 6.25 5.36251 6.1825Z"
                          fill="white"
                        />
                        <path
                          d="M5.36251 7.02002C5.38251 7.08002 5.40501 7.14002 5.42501 7.20002C5.49001 7.18752 5.55751 7.17502 5.62251 7.16252C5.56751 7.21252 5.51501 7.26252 5.46251 7.31002C5.48251 7.37002 5.50251 7.42752 5.52501 7.48752C5.47001 7.46002 5.41751 7.43002 5.36251 7.40002C5.31001 7.44752 5.25501 7.49752 5.20251 7.54502C5.22251 7.47752 5.24251 7.41252 5.26251 7.34502C5.21001 7.31502 5.15501 7.28502 5.10251 7.25502C5.16751 7.24502 5.23501 7.23252 5.30251 7.22252C5.32251 7.15502 5.34251 7.08752 5.36251 7.02002Z"
                          fill="white"
                        />
                        <path
                          d="M5.36251 7.86011C5.38251 7.92011 5.40501 7.98011 5.42501 8.04011C5.49001 8.02761 5.55751 8.01511 5.62251 8.00261C5.56751 8.05261 5.51501 8.10011 5.46251 8.15011C5.48251 8.21011 5.50251 8.27011 5.52501 8.33011C5.47001 8.30261 5.41751 8.27261 5.36251 8.24261C5.31001 8.29011 5.25501 8.34011 5.20251 8.38761C5.22251 8.32011 5.24251 8.25261 5.26251 8.18761C5.21001 8.15761 5.15501 8.12761 5.10251 8.09761C5.16751 8.08761 5.23501 8.07511 5.30251 8.06511C5.32251 7.99511 5.34251 7.92761 5.36251 7.86011Z"
                          fill="white"
                        />
                        <path
                          d="M5.9475 4.83252C5.9675 4.89252 5.9875 4.95002 6.01 5.01002C6.075 4.99502 6.1425 4.98002 6.21 4.96752C6.1575 5.01752 6.1025 5.07002 6.05 5.12002C6.07 5.17752 6.09 5.23752 6.11 5.29502C6.055 5.26752 6.0025 5.24002 5.9475 5.21252C5.8925 5.26252 5.84 5.31252 5.785 5.36252C5.805 5.29502 5.8275 5.22752 5.8475 5.16002C5.795 5.13252 5.74 5.10252 5.6875 5.07502C5.7525 5.06252 5.82 5.04752 5.885 5.03502C5.9075 4.96752 5.9275 4.90002 5.9475 4.83252Z"
                          fill="white"
                        />
                        <path
                          d="M5.9475 5.67261C5.9675 5.73261 5.9875 5.79011 6.01 5.85011C6.075 5.83511 6.1425 5.82011 6.21 5.80761C6.1575 5.85761 6.1025 5.91011 6.05 5.96011C6.07 6.02011 6.09 6.07761 6.11 6.13761C6.055 6.11011 6.0025 6.08261 5.9475 6.05511C5.8925 6.10511 5.84 6.15511 5.785 6.20511C5.805 6.13761 5.8275 6.07011 5.8475 6.00261C5.795 5.97511 5.74 5.94511 5.6875 5.91761C5.7525 5.90511 5.82 5.89011 5.885 5.87761C5.9075 5.80761 5.9275 5.74011 5.9475 5.67261Z"
                          fill="white"
                        />
                        <path
                          d="M5.9475 6.51001C5.9675 6.57001 5.9875 6.62751 6.01 6.68751C6.075 6.67251 6.1425 6.66001 6.21 6.64501C6.1575 6.69501 6.1025 6.74501 6.05 6.79751C6.07 6.85751 6.09 6.91501 6.11 6.97501C6.055 6.94751 6.0025 6.92001 5.9475 6.89251C5.8925 6.94251 5.84 6.99251 5.785 7.04501C5.805 6.97751 5.8275 6.91001 5.8475 6.84251C5.795 6.81501 5.74 6.78501 5.6875 6.75751C5.7525 6.74501 5.82 6.73251 5.885 6.71751C5.9075 6.64501 5.9275 6.57751 5.9475 6.51001Z"
                          fill="white"
                        />
                        <path
                          d="M5.9475 7.34998C5.9675 7.40748 5.9875 7.46748 6.01 7.52498C6.075 7.50998 6.1425 7.49748 6.21 7.47998C6.1575 7.52998 6.1025 7.58248 6.05 7.63248C6.07 7.68998 6.09 7.74998 6.11 7.80748C6.055 7.77998 6.0025 7.75248 5.9475 7.72498C5.8925 7.77498 5.84 7.82498 5.785 7.87498C5.805 7.80748 5.8275 7.73998 5.8475 7.67248C5.795 7.64498 5.74 7.61498 5.6875 7.58748C5.7525 7.57498 5.82 7.55998 5.885 7.54748C5.9075 7.48498 5.9275 7.41748 5.9475 7.34998Z"
                          fill="white"
                        />
                        <path
                          d="M6.53753 4.25745C6.55753 4.31495 6.58003 4.37495 6.60003 4.43245C6.66753 4.41745 6.73253 4.39995 6.80003 4.38495C6.74503 4.43745 6.69253 4.48995 6.64003 4.54245C6.66003 4.59995 6.68003 4.65745 6.70253 4.71745C6.64753 4.69245 6.59253 4.66495 6.53753 4.63995C6.48503 4.69245 6.43003 4.74245 6.37753 4.79495C6.39753 4.72745 6.41753 4.65995 6.43753 4.58995C6.38253 4.56245 6.33003 4.53745 6.27753 4.50995C6.34503 4.49495 6.41003 4.47995 6.47753 4.46495C6.49753 4.39495 6.51753 4.32745 6.53753 4.25745Z"
                          fill="white"
                        />
                        <path
                          d="M6.53753 5.09753C6.55753 5.15503 6.58003 5.21253 6.60003 5.27253C6.66753 5.25753 6.73253 5.24003 6.80003 5.22503C6.74503 5.27753 6.69253 5.33003 6.64003 5.38003C6.66003 5.43753 6.68003 5.49753 6.70253 5.55503C6.64753 5.53003 6.59253 5.50253 6.53753 5.47753C6.48503 5.53003 6.43003 5.58003 6.37753 5.63253C6.39753 5.56503 6.41753 5.49503 6.43753 5.42753C6.38253 5.40003 6.33003 5.37503 6.27753 5.34753C6.34503 5.33253 6.41003 5.31753 6.47753 5.30253C6.49753 5.23503 6.51753 5.16503 6.53753 5.09753Z"
                          fill="white"
                        />
                        <path
                          d="M6.53753 5.93506C6.55753 5.99256 6.58003 6.05256 6.60003 6.11006C6.66753 6.09506 6.73253 6.07756 6.80003 6.06256C6.74503 6.11506 6.69253 6.16756 6.64003 6.21756C6.66003 6.27506 6.68003 6.33506 6.70253 6.39256C6.64753 6.36756 6.59253 6.34006 6.53753 6.31506C6.48503 6.36756 6.43003 6.41756 6.37753 6.47006C6.39753 6.40256 6.41753 6.33256 6.43753 6.26506C6.38253 6.23756 6.33003 6.21256 6.27753 6.18506C6.34503 6.17006 6.41003 6.15506 6.47753 6.14006C6.49753 6.07256 6.51753 6.00506 6.53753 5.93506Z"
                          fill="white"
                        />
                        <path
                          d="M6.53753 6.77502C6.55753 6.83252 6.58003 6.89252 6.60003 6.95002C6.66753 6.93502 6.73253 6.91752 6.80003 6.90252C6.74503 6.95502 6.69253 7.00752 6.64003 7.06002C6.66003 7.11752 6.68003 7.17502 6.70253 7.23502C6.64753 7.21002 6.59253 7.18252 6.53753 7.15752C6.48503 7.20752 6.43003 7.26002 6.37753 7.31002C6.39753 7.24252 6.41753 7.17502 6.43753 7.10752C6.38253 7.08002 6.33003 7.05252 6.27753 7.02752C6.34503 7.01252 6.41003 6.99752 6.47753 6.98252C6.49753 6.91252 6.51753 6.84252 6.53753 6.77502Z"
                          fill="white"
                        />
                        <path
                          d="M6.53753 7.61499C6.55753 7.67249 6.58003 7.73249 6.60003 7.78999C6.66753 7.77499 6.73253 7.75749 6.80003 7.74249C6.74503 7.79499 6.69253 7.84749 6.64003 7.89749C6.66003 7.95499 6.68003 8.01499 6.70253 8.07249C6.64753 8.04749 6.59253 8.01999 6.53753 7.99499C6.48503 8.04499 6.43003 8.09749 6.37753 8.14999C6.39753 8.08249 6.41753 8.01249 6.43753 7.94499C6.38253 7.91749 6.33003 7.89249 6.27753 7.86499C6.34503 7.84999 6.41003 7.83499 6.47753 7.81999C6.49753 7.74999 6.51753 7.68249 6.53753 7.61499Z"
                          fill="white"
                        />
                      </svg>
                      ENG
                    </li>
                    <hr />
                    <li>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="mr-2"
                      >
                        <path
                          d="M0 12.6676C5.3325 15.4676 10.6675 9.86758 16 12.6676C16 9.55508 16 6.44508 16 3.33258C10.6675 0.532582 5.3325 6.13258 0 3.33258C0 6.44508 0 9.55508 0 12.6676Z"
                          fill="#C8202C"
                        />
                        <path
                          d="M9.13001 8.37012C9.36251 9.03012 9.59501 9.69262 9.82751 10.3576C9.21751 10.0501 8.60751 9.76762 8.00001 9.48262C7.39001 10.0851 6.78001 10.6901 6.17001 11.2676C6.40251 10.4976 6.63501 9.72762 6.86751 8.95262C6.25751 8.66012 5.64751 8.35262 5.04001 8.00512C5.79251 7.88762 6.54751 7.71012 7.30001 7.51512C7.53251 6.73762 7.76501 5.96012 7.99751 5.18262C8.23001 5.83762 8.46501 6.49512 8.69751 7.15012C9.45001 6.95762 10.2025 6.77762 10.9575 6.66262C10.35 7.20012 9.74001 7.77762 9.13001 8.37012Z"
                          fill="#F3EA32"
                        />
                      </svg>
                      VIE
                    </li>
                    <hr />
                    <li>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="mr-2"
                      >
                        <path
                          d="M0 6.44508C5.3325 9.24508 10.6675 3.64508 16 6.44508C16 5.40758 16 4.37008 16 3.33258C10.6675 0.532582 5.3325 6.13258 0 3.33258C0 4.37008 0 5.40758 0 6.44508Z"
                          fill="#F3F4F5"
                        />
                        <path
                          d="M0 9.55507C5.3325 12.3551 10.6675 6.75507 16 9.55507C16 8.51757 16 7.48007 16 6.44257C10.6675 3.64257 5.3325 9.24257 0 6.44257C0 7.48007 0 8.51757 0 9.55507Z"
                          fill="#314094"
                        />
                        <path
                          d="M0 12.6676C5.3325 15.4676 10.6675 9.86762 16 12.6676C16 11.6301 16 10.5926 16 9.55512C10.6675 6.75512 5.3325 12.3551 0 9.55512C0 10.5926 0 11.6301 0 12.6676Z"
                          fill="#D71F26"
                        />
                      </svg>
                      RU
                    </li>
                  </ul>
                </div>
              )}
            </div> */}

            {/* Mobile Notifications */}
            <div
              className="navbar-brand n-notificationHover position-relative w-nav-mob"
              style={{
                height: "40px",
                marginRight: "32px",
                paddingBottom: "41px",
              }}
              onClick={handleNotificationsDropdown}
              ref={myRef}
            >
              <Link
                to={browserRoute.NOTIFICATIONS}
                className={
                  "" +
                  (window.location.href.indexOf(browserRoute.NOTIFICATIONS) !==
                  -1
                    ? ""
                    : null)
                }
              >
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M29 26.0233C29 26.5113 28.6043 26.907 28.1163 26.907H11.8837C11.3957 26.907 11 26.5113 11 26.0233V26.0233C11 25.5352 11.3957 25.1395 11.8837 25.1395H11.9V18.9809C11.9 14.5729 15.527 11 20 11C24.473 11 28.1 14.5729 28.1 18.9809V25.1395H28.1163C28.6043 25.1395 29 25.5352 29 26.0233V26.0233ZM13.7 25.1395H26.3V18.9809C26.3 15.5494 23.4794 12.7674 20 12.7674C16.5206 12.7674 13.7 15.5494 13.7 18.9809V25.1395ZM17.976 28.7558C17.7312 28.2608 18.1977 27.7907 18.75 27.7907H21.25C21.8023 27.7907 22.2688 28.2608 22.024 28.7558C21.9155 28.9751 21.7699 29.1773 21.591 29.3529C21.169 29.7672 20.5967 30 20 30C19.4033 30 18.831 29.7672 18.409 29.3529C18.2301 29.1773 18.0845 28.9751 17.976 28.7558Z"
                    fill="#777E91"
                  />
                </svg>
                {unReadNotifications && (
                  <img
                    src={Images.notificationdot}
                    style={{
                      position: "absolute",

                      // backgroundColor: "red",
                      left: "22px",
                      top: "10px",
                    }}
                  />
                )}
              </Link>
            </div>
            {/*End Mobile Notifications */}
            <div
              className="navbar-brand n-notificationHover position-relative w-nav-web"
              style={{
                height: "40px",
                marginRight: "32px",
                paddingBottom: "41px",
                // cursor: "pointer",
                marginBottom: "4px",
              }}
              onClick={handleNotificationsDropdown}
              ref={myRef}
            >
              {/* <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="28" width="12" height="12" rx="6" fill="#58BD7D" />
                <path
                  d="M29 26.0233C29 26.5113 28.6043 26.907 28.1163 26.907H11.8837C11.3957 26.907 11 26.5113 11 26.0233C11 25.5352 11.3957 25.1395 11.8837 25.1395H11.9V18.9809C11.9 14.5729 15.527 11 20 11C24.473 11 28.1 14.5729 28.1 18.9809V25.1395H28.1163C28.6043 25.1395 29 25.5352 29 26.0233ZM13.7 25.1395H26.3V18.9809C26.3 15.5494 23.4794 12.7674 20 12.7674C16.5206 12.7674 13.7 15.5494 13.7 18.9809V25.1395ZM17.976 28.7558C17.7312 28.2608 18.1977 27.7907 18.75 27.7907H21.25C21.8023 27.7907 22.2688 28.2608 22.024 28.7558C21.9155 28.9751 21.7699 29.1773 21.591 29.3529C21.169 29.7672 20.5967 30 20 30C19.4033 30 18.831 29.7672 18.409 29.3529C18.2301 29.1773 18.0845 28.9751 17.976 28.7558Z"
                  fill="#777E91"
                />
              </svg> */}
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M29 26.0233C29 26.5113 28.6043 26.907 28.1163 26.907H11.8837C11.3957 26.907 11 26.5113 11 26.0233V26.0233C11 25.5352 11.3957 25.1395 11.8837 25.1395H11.9V18.9809C11.9 14.5729 15.527 11 20 11C24.473 11 28.1 14.5729 28.1 18.9809V25.1395H28.1163C28.6043 25.1395 29 25.5352 29 26.0233V26.0233ZM13.7 25.1395H26.3V18.9809C26.3 15.5494 23.4794 12.7674 20 12.7674C16.5206 12.7674 13.7 15.5494 13.7 18.9809V25.1395ZM17.976 28.7558C17.7312 28.2608 18.1977 27.7907 18.75 27.7907H21.25C21.8023 27.7907 22.2688 28.2608 22.024 28.7558C21.9155 28.9751 21.7699 29.1773 21.591 29.3529C21.169 29.7672 20.5967 30 20 30C19.4033 30 18.831 29.7672 18.409 29.3529C18.2301 29.1773 18.0845 28.9751 17.976 28.7558Z"
                  fill="#777E91"
                />
              </svg>
              {unReadNotifications && (
                <img
                  src={Images.notificationdot}
                  style={{
                    position: "absolute",

                    // backgroundColor: "red",
                    left: "22px",
                    top: "10px",
                  }}
                />
              )}

              {/* <img src={bell} style={{ cursor: "pointer" }} /> */}
              {/* <div className="n-notificationCap">
                <img src={Images.cap} />
              </div> */}
              {notificationPopup && (
                <div className="n-notificationMainDropDown">
                  <span class="triangle"></span>
                  <div className="n-notificationDropDown">
                    <div className="n-notificationBody">
                      <h5>Notifications</h5>
                      <ul className="n-notificationsList">
                        {console.log(
                          "><>< NOTIFICATION DATA ><><> ",
                          nData?.slice(0, 3)
                        )}
                        {nData?.length > 0 ? (
                          <>
                            {nData?.slice(0, 3)?.map((e) => (
                              <>
                                <li className="d-flex flex-row align-items-start justify-content-between">
                                  <div className="n-notificationContent">
                                    <div className="d-flex flex-row justify-content-between align-items-center">
                                      <h6>
                                        {/* Login attempted from new IP */}
                                        Received : {e.amount} {e.coin}
                                      </h6>
                                      {!e.isVisited && (
                                        <img src={Images.notificationdot} />
                                      )}
                                    </div>
                                    <p>
                                      {/* 2021-03-10 20:19:15 */}
                                      {e.date.substring(0, 16)}
                                    </p>
                                  </div>
                                </li>
                              </>
                            ))}
                          </>
                        ) : (
                          <li className="d-flex flex-row align-items-start justify-content-between">
                            <div className="n-notificationContent">
                              <h6>No notifications available</h6>
                            </div>
                          </li>
                        )}
                        <hr />
                        {/* <li className="d-flex flex-row align-items-start justify-content-between">
                          <div className="n-notificationContent">
                            <div className="d-flex flex-row justify-content-between align-items-center">
                              <h6>Login attempted from new IP</h6>
                              <img src={Images.notificationdot} />
                            </div>
                            <p>2021-03-10 20:19:15</p>
                          </div>
                        </li>
                        <hr />
                        <li className="d-flex flex-row align-items-start justify-content-between">
                          <div className="n-notificationContent">
                            <div className="d-flex flex-row justify-content-between align-items-center">
                              <h6>Login attempted from new IP</h6>
                              <img src={Images.notificationdot} />
                            </div>
                            <p>2021-03-10 20:19:15</p>
                          </div>
                        </li> */}
                      </ul>
                      <div class="n-notificationButtons d-fex flex-row align-items-center w-100">
                        <Link
                          // style={{color:"#fcfcfd"}}
                          to={browserRoute.NOTIFICATIONS}
                          className={
                            "" +
                            (window.location.href.indexOf(
                              browserRoute.NOTIFICATIONS
                            ) !== -1
                              ? ""
                              : null)
                          }
                        >
                          <button class="n-primaryButton n-primaryDark w-100">
                            View all
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <span
              className="navbar-brand"
              to="/"
              style={{ marginRight: "32px", paddingBottom: "11px" }}
            >
              {/* <img
                style={{ cursor: "pointer" }}
                src={doticon}
                onClick={() => {
                  darkmode.toggle();
                }}
              /> */}
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  darkmode.toggle();
                }}
                class="n-darkThemeToggle"
              >
                <path
                  d="M12 2C11.4477 2 11 2.44772 11 3C11 3.55228 11.4477 4 12 4C12.5523 4 13 3.55228 13 3C13 2.44772 12.5523 2 12 2Z"
                  fill="#777E91"
                />
                <path
                  d="M12 20C11.4477 20 11 20.4477 11 21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21C13 20.4477 12.5523 20 12 20Z"
                  fill="#777E91"
                />
                <path
                  d="M21 11C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13C20.4477 13 20 12.5523 20 12C20 11.4477 20.4477 11 21 11Z"
                  fill="#777E91"
                />
                <path
                  d="M4 12C4 11.4477 3.55228 11 3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13C3.55228 13 4 12.5523 4 12Z"
                  fill="#777E91"
                />
                <path
                  d="M17.6569 4.92903C18.0474 4.53851 18.6806 4.53851 19.0711 4.92903C19.4616 5.31955 19.4616 5.95272 19.0711 6.34324C18.6806 6.73377 18.0474 6.73377 17.6569 6.34324C17.2664 5.95272 17.2664 5.31955 17.6569 4.92903Z"
                  fill="#777E91"
                />
                <path
                  d="M6.34309 17.6568C5.95257 17.2663 5.3194 17.2663 4.92888 17.6568C4.53836 18.0473 4.53836 18.6805 4.92888 19.071C5.3194 19.4616 5.95257 19.4616 6.34309 19.071C6.73362 18.6805 6.73362 18.0473 6.34309 17.6568Z"
                  fill="#777E91"
                />
                <path
                  d="M19.0711 17.6569C19.4616 18.0474 19.4616 18.6806 19.0711 19.0711C18.6806 19.4616 18.0474 19.4616 17.6569 19.0711C17.2664 18.6806 17.2664 18.0474 17.6569 17.6569C18.0474 17.2664 18.6806 17.2664 19.0711 17.6569Z"
                  fill="#777E91"
                />
                <path
                  d="M6.34319 6.34309C6.73371 5.95257 6.73371 5.3194 6.34319 4.92888C5.95266 4.53836 5.3195 4.53836 4.92897 4.92888C4.53845 5.3194 4.53845 5.95257 4.92897 6.34309C5.3195 6.73362 5.95266 6.73362 6.34319 6.34309Z"
                  fill="#777E91"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
                  fill="#777E91"
                />
              </svg>
            </span>

            <button
              class="btn n-secondaryButton my-2 my-sm-0 n-secondaryHeaderDark"
              type="submit"
              style={{ boxShadow: "none" }}
              onClick={() => {
                loggedIn ? handleDisconnect() : setMainModel(true);
              }}
            >
              {title}
              {/* Wallet */}
            </button>
          </div>
        </nav>
      </div>
      <div className="solid solidclasssheader"></div>
    </div>
  );
};
export default Header;
